<template>
  <a-modal
    style="position: relative"
    v-model="NewlyaddedOrderListible"
    footer="'"
    title="新建订单"
    width="1300px"
    :maskClosable="false"
  >
    <!--下单要求-->
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form">
          <div style="background-color: rgb(230, 247, 255)">
            <a-row style="padding: 0px">
              <a-col :span="24" class="orderKeyword">
                <span>下单要求</span>
              </a-col>
            </a-row>
            <div v-if="order_demand.demandList">
              <ul v-for="(tab, index) in order_demand.demandList.create_order_demand" :key="index">
                <li>{{ index + 1 }}.{{ tab.demandContent }}</li>
              </ul>
            </div>
          </div>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false" style="margin-top: 20px">
      <!--基础信息-->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form" selfUpdate="true">
          <a-row :gutter="24" style="margin-left: 20px">
            <a-col :md="22" :sm="24">
              <a-form-item label="地址解析" style="width: 100%; margin-left: 12px">
                <a-input placeholder="粘贴地址信息，自动拆分姓名，电话和地址；" v-model="resolution" />
              </a-form-item>
            </a-col>
            <a-col :md="2" :sm="24" style="text-align: right">
              <a-button type="primary" @click="addressResolution">解析</a-button>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="3">
              <div class="orderKeyword" style="margin: 20px 0">
                <span style="font-size: 24px; font-weight: bold">基础信息</span>
              </div>
            </a-col>
            <a-col :span="20">
              <div>
                <a-button :type="isSmsWarnbool ? 'danger' : 'primary'" @click="isSmsWarn" style="margin: 20px 10px"
                  >短信提醒
                </a-button>
                <a-button
                  :type="isMainOrderbool ? 'danger' : 'primary'"
                  @click="isorderImportant"
                  style="margin: 20px 10px"
                  >重要下单
                </a-button>

                <a-button
                  :type="isUrgentOrder == 0 ? 'primary' : 'danger'"
                  @click="isOrderUrgent"
                  style="margin: 20px 10px"
                  >加急订单</a-button
                >

                <a-button :type="isSerialNotice ? 'danger' : 'primary'" @click="isSmsWarn2" style="margin: 20px 10px">
                  产品条形码</a-button
                >
                <a-button :type="factoryStatus ? 'danger' : 'primary'" @click="changeFactory" style="margin: 20px 10px">
                  旧件返厂</a-button
                >
                <!--<a-button type="primary"  style="margin: 20px 10px">补单通知</a-button>-->
              </div>
            </a-col>
          </a-row>
          <a-row :gutter="24" style="margin-left: 20px">
            <a-col :md="6" :sm="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 25px">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                    >订单号 :
                  </span>
                  <a-input v-decorator="['orderNo']" disabled="disabled" autocomplete="off" />
                  <a-icon
                    @click="getOrderNum"
                    style="margin: 6px 0px 0px 5px; color: #1890ff; fontsize: 20px"
                    title="重新获取订单号"
                    type="sync"
                    :spin="spinlogin"
                  />
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                    >原始单号 :
                  </span>
                  <a-input v-decorator="['originalOrderNo']" autocomplete="off" />
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                    >序列号 :
                  </span>
                  <a-input v-decorator="['serialNumber']" autocomplete="off" />
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <div style="display: flex; width: 100%">
                  <span
                    style="
                      width: 40%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    <span style="color: red">*</span> 企业名称 :
                  </span>
                  <a-select
                    :getPopupContainer="getPopupContainer"
                    showSearch
                    style="width: 55%"
                    optionFilterProp="children"
                    :disabled="EnterDisabled"
                    @change="enterpriseChange($event)"
                    :filterOption="filterOption"
                    autocomplete="off"
                    v-decorator="['enterpriseId', { rules: [{ required: true, message: '请选择企业名称!' }] }]"
                  >
                    <a-select-option v-for="type in selectCombox" :key="type.enterpriseId"
                      >{{ type.enterpriseName }}
                    </a-select-option>
                  </a-select>
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    <span style="color: red">*</span> 安装类别 :
                  </span>
                  <a-select
                    :getPopupContainer="getPopupContainer"
                    v-decorator="['installType', { rules: [{ required: true, message: '请选择安装类别!' }] }]"
                    @change="installChange"
                    autocomplete="off"
                  >
                    <a-select-option v-for="type in installTypes" :key="type.installationTypeCode">{{
                      type.installationTypeName
                    }}</a-select-option>
                  </a-select>
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    <span style="color: red">*</span> 订单类型 :
                  </span>
                  <a-select
                    :getPopupContainer="getPopupContainer"
                    autocomplete="off"
                    v-decorator="['orderType', { rules: [{ required: true, message: '请选择订单类型!' }] }]"
                    @change="orderChange"
                  >
                    <a-select-option v-for="type in List" :key="type.orderTypeId">{{ type.typeName }}</a-select-option>
                  </a-select>
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    <span style="color: red">*</span> 数量 :
                  </span>
                  <a-input-number
                    :min="1"
                    autocomplete="off"
                    v-decorator="['number', { rules: [{ required: true, message: '请填写数量!' }], initialValue: 1 }]"
                    style="width: 100%"
                  />
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    <span style="color: red">*</span> 付款方式 :
                  </span>
                  <a-select
                    :getPopupContainer="getPopupContainer"
                    v-decorator="['payType', { rules: [{ required: true, message: '请选择付款方式!' }] }]"
                  >
                    <a-select-option v-for="type in pay_type" :key="type.dictValue">{{
                      type.dictLabel
                    }}</a-select-option>
                  </a-select>
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                    ><span style="color: red">*</span>品牌 :
                  </span>
                  <a-select
                    :getPopupContainer="getPopupContainer"
                    showSearch
                    optionFilterProp="children"
                    @change="changeBrandName"
                    :filterOption="filterOption"
                    v-decorator="['brandId', { rules: [{ required: true, message: '请选择品牌!' }] }]"
                    autocomplete="off"
                    :allowClear="true"
                  >
                    <!--, {initialValue:this.brandinitialValue }-->
                    <a-select-option v-for="type in selectBrand" :key="type.brandId"
                      >{{ type.brandName }}
                    </a-select-option>
                  </a-select>
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                    ><span style="color: red">*</span>型号:
                  </span>
                  <a-select
                    :getPopupContainer="getPopupContainer"
                    showSearch
                    optionFilterProp="children"
                    @change="changeModelName"
                    :filterOption="filterOption"
                    v-decorator="['modelId', { rules: [{ required: true, message: '请选择型号!' }] }]"
                    autocomplete="off"
                    :allowClear="true"
                  >
                    <!--, {initialValue:this.modelinitialValue }-->
                    <a-select-option v-for="type in selectModel" :key="type.modelId"
                      >{{ type.modelName }}
                    </a-select-option>
                  </a-select>
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    规格（长度）(mm) :
                  </span>
                  <a-input :value="modelSpecLength" disabled placeholder="自动带入" />
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    规格（宽度）(mm) :
                  </span>
                  <a-input :value="modelSpecWidth" disabled placeholder="自动带入" />
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                    >购买渠道 :
                  </span>
                  <a-select
                    :getPopupContainer="getPopupContainer"
                    showSearch
                    optionFilterProp="children"
                    @change="changesourceName"
                    :filterOption="filterOption"
                    v-decorator="['buyChannelId']"
                    autocomplete="off"
                    :allowClear="true"
                  >
                    <a-select-option v-for="type in selectChannel" :key="type.channelId"
                      >{{ type.channelName }}
                    </a-select-option>
                  </a-select>
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                    >信息来源 :
                  </span>
                  <a-select
                    :getPopupContainer="getPopupContainer"
                    showSearch
                    optionFilterProp="children"
                    @change="changeinfoSourceName"
                    :filterOption="filterOption"
                    v-decorator="['infoSourceId']"
                    autocomplete="off"
                    :allowClear="true"
                  >
                    <a-select-option v-for="type in selectSource" :key="type.sourceId"
                      >{{ type.sourceName }}
                    </a-select-option>
                  </a-select>
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    门厚(mm) :
                  </span>
                  <a-input-number
                    style="width: 100%"
                    :min="0"
                    :max="99999"
                    :step="1"
                    :precision="0"
                    placeholder="请输入0-99999整数"
                    v-decorator="['doorThickness']"
                  />
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="">
                <div style="display: flex">
                  <span
                    style="
                      width: 100%;
                      margin-right: 6px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    是否有导向片 :
                  </span>
                  <a-select style="width:100%" v-decorator="['isCounterVane', { initialValue: 1 }]"
                    @change="onHasCounterVaneChange" placeholder="请选择">
                    <a-select-option v-for="item in hasCounterVaneOptions" :key="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="showCounterVaneFields">
              <a-form-item label="">
                <div style="display: flex">
                  <span
                    style="
                      width: 100%;
                      margin-right: 6px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    <span style="color: red">*</span> 导向片长度(mm) :
                  </span>
                  <a-input-number
                    style="width: 100%"
                    :min="0"
                    :max="99999"
                    :step="1"
                    :precision="0"
                    placeholder="请输入0-99999整数"
                    v-decorator="['counterVaneLength', { rules: [{ required: true, message: '请输入导向片长度' }] }]"
                  />
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="showCounterVaneFields">
              <a-form-item label="">
                <div style="display: flex">
                  <span
                    style="
                      width: 100%;
                      margin-right: 6px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    <span style="color: red">*</span> 导向片宽度(mm) :
                  </span>
                  <a-input-number
                    style="width: 100%"
                    :min="0"
                    :max="99999"
                    :step="1"
                    :precision="0"
                    placeholder="请输入0-99999整数"
                    v-decorator="['counterVaneWidth', { rules: [{ required: true, message: '请输入导向片宽度' }] }]"
                  />
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                    >是否配件随货:
                  </span>
                  <a-select
                    :getPopupContainer="getPopupContainer"
                    showSearch
                    optionFilterProp="children"
                    @change="changeAccessories"
                    :filterOption="filterOption"
                    v-decorator="['sparepart']"
                    autocomplete="off"
                    :allowClear="true"
                  >
                    <a-select-option v-for="item in accessoriesOptions" :key="item.code"
                      >{{ item.label }}
                    </a-select-option>
                  </a-select>
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-for="(tab, index) in customInfo" :key="index">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                    >{{ tab }}
                    :
                  </span>
                  <a-input
                    autocomplete="off"
                    v-decorator="[index == 2 ? 'thirdValue' : index == 1 ? 'secondValue' : 'firstValue']"
                  />
                </div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24" style="margin-left: 20px">
            <a-col :md="6" :sm="24">
              <a-form-item label="">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    <span style="color: red">*</span> 客户姓名 :
                  </span>
                  <a-input
                    autocomplete="off"
                    v-decorator="['clientName', { rules: [{ required: true, message: '请填写客户姓名!' }] }]"
                  />
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    <span style="color: red">*</span> 联系方式 :
                  </span>
                  <a-input
                    autocomplete="off"
                    v-decorator="[
                      'clientPhone',
                      { rules: [{ required: true, message: '请填写联系方式!', pattern: /^1[3456789]\d{9}$/ }] },
                    ]"
                    @change="changePhone"
                  />
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item label="" style="margin-left: -15px">
                <div style="display: flex">
                  <span
                    style="
                      width: 53%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                    >期望安装时间 :
                  </span>
                  <a-date-picker
                    @change="onChangerangepicker"
                    style="width: 100%"
                    autocomplete="off"
                    v-decorator="['expectinstallTime']"
                  />
                  <a-select
                    :getPopupContainer="getPopupContainer"
                    @change="onChanginstallTimeible"
                    autocomplete="off"
                    v-decorator="['installTimePart']"
                    :allowClear="true"
                  >
                    <a-select-option v-for="type in timeselect" :key="type.value">{{ type.label }}</a-select-option>
                  </a-select>
                </div>
                <!--, { rules: [{ required: this.expectinstallTimeible, message:'请填写期望安装时间!' }] }-->
              </a-form-item>
            </a-col>
          </a-row>
          <a-row style="margin-left: 20px">
            <a-col :span="6">
              <a-form-item label="">
                <div style="display: flex">
                  <span
                    style="
                      width: 68%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    <span style="color: red">*</span> 客户地址 :
                  </span>
                  <a-select
                    :getPopupContainer="getPopupContainer"
                    showSearch
                    :filterOption="filterOption"
                    @change="getselect"
                    autocomplete="off"
                    v-decorator="['provinceCode', { rules: [{ required: true, message: '请选择客户地址!' }] }]"
                  >
                    <a-select-option
                      v-for="type in selectAllProvince"
                      :title="type.provinceName"
                      :key="type.provinceCode"
                      >{{ type.provinceName }}
                    </a-select-option>
                  </a-select>
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="3">
              <a-form-item>
                <a-select
                  :getPopupContainer="getPopupContainer"
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  autocomplete="off"
                  v-decorator="['cityCode', { rules: [{ required: true, message: '市' }] }]"
                  @change="getprovinceName"
                >
                  <a-select-option v-for="type in selectCityName" :title="type.cityName" :key="type.cityCode"
                    >{{ type.cityName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="3">
              <a-form-item>
                <a-select
                  :getPopupContainer="getPopupContainer"
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  autocomplete="off"
                  v-decorator="['areaCode', { rules: [{ required: true, message: '区' }] }]"
                >
                  <a-select-option v-for="type in selectAreaName" :title="type.areaName" :key="type.areaCode"
                    >{{ type.areaName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="" style="margin-left: 24px">
                <div style="display: flex">
                  <span
                    style="
                      width: 22%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    <span style="color: red">*</span> 详细地址 :
                  </span>
                  <a-input
                    autocomplete="off"
                    v-decorator="[
                      'clientAddress',
                      {
                        rules: [
                          {
                            required: true,
                            message: '请填写详细地址!',
                          },
                        ],
                      },
                    ]"
                    @blur="changeAddress"
                  />
                </div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24" style="margin-left: 20px" v-if="this.factoryStatus">
            <a-col :md="6" :sm="24">
              <a-form-item label="">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    箱码 :
                  </span>
                  <a-input autocomplete="off" v-decorator="['caseCode']" />
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="">
                <div style="display: flex">
                  <span
                    style="
                      width: 70%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    旧件码 :
                  </span>
                  <a-input autocomplete="off" v-decorator="['oldPartCode']" />
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <div style="display: flex">
                  <span
                    style="
                      width: 22%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    <span style="color: red">*</span> 寄回要求 :
                  </span>
                  <a-select
                    :getPopupContainer="getPopupContainer"
                    showSearch
                    notFoundContent="请至【企业列表】完善寄回要求"
                    @change="sendBackListChange($event)"
                    autocomplete="off"
                    v-decorator="['enterpriseSendBackId', { rules: [{ required: true, message: '请选择寄件要求!' }] }]"
                  >
                    <a-select-option v-for="type in sendBackList" :key="type.id"
                      >{{ type.requirement }}
                    </a-select-option>
                  </a-select>
                </div>
              </a-form-item>
            </a-col>

            <a-col :span="24">
              <a-form-item>
                <div style="display: flex">
                  <span
                    style="
                      width: 10%;
                      margin-right: 11px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                  >
                    <span style="color: red">*</span> 旧件寄回地址 :
                  </span>
                  <a-select
                    :getPopupContainer="getPopupContainer"
                    notFoundContent="请至【企业列表】完善旧件寄回地址"
                    v-decorator="[
                      'enterpriseAddressId',
                      { rules: [{ required: true, message: '请选择旧件寄回地址!' }] },
                    ]"
                  >
                    <a-select-option v-for="type in address_type" :key="type.id">{{
                      type.contact + '-' + type.phoneNumber + '-' + type.address
                    }}</a-select-option>
                  </a-select>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24" style="margin-left: 20px">
            <a-col :md="12" :sm="24" v-if="store.getters.userType != '22'">
              <a-form-item label="">
                <div style="display: flex">
                  <span
                    style="
                      width: 23%;
                      margin-right: 15px;
                      text-align: right;
                      color: rgba(0, 0, 0, 0.85);
                      font-size: 14px;
                    "
                    >客户要求 :
                  </span>
                  <a-input
                    placeholder="注意：此要求师傅可看，仅限派单前填写；"
                    v-decorator="['clientRequire']"
                    autocomplete="off"
                  />
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-button type="primary" @click="substituteInformation">代入信息</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!--师傅备注-->
      <div class="table-page-search-wrapper" v-if="store.getters.userType == '00'">
        <a-form layout="inline" :form="form" selfUpdate="true">
          <div class="orderKeyword" style="margin: 20px 0px">
            <label style="font-size: 24px; font-weight: bold">师傅备注</label>
          </div>
          <a-row>
            <a-col :span="20">
              <div v-if="masterNotesExpand">
                <div v-for="(tab, index) in comments.slice(0, 8)" :key="index" style="margin-bottom: 15px">
                  <a-row type="flex" align="middle">
                    <a-col :span="6">
                      <a-row style="margin-left: -4.5px">
                        <a-col :span="1" style="margin-top: 4px; margin-right: 15px"></a-col>
                        <a-col :span="20" v-if="!tab.demandId">
                          <div style="margin-left: 20px; display: flex; align-items: center">
                            <a-button type="primary" style="margin: 0 10px" @click="editRemark(tab)">编辑 </a-button>
                            <a-button
                              type="primary"
                              style="margin-right: 10px"
                              v-if="tab.flag === true"
                              @click="preservation(tab)"
                              >保存
                            </a-button>
                            <a-button type="primary" style="" @click="removeTab(tab)">删除</a-button>
                          </div>
                        </a-col>
                      </a-row>
                    </a-col>
                    <a-col :span="18">
                      <a-row type="flex" align="middle" style="margin-top: 4px">
                        <a-col :span="10">
                          <span style="margin-top: 4px">
                            <span v-if="tab.flag === false">
                              {{ tab.remarkInfo }}
                            </span>
                            <span v-if="tab.flag === true">
                              <a-input v-model.trim="tab.remarkInfo" @change="onchangeiInput" style="width: 100%" />
                            </span>
                          </span>
                        </a-col>
                        <a-col :span="7">
                          <span style="margin-top: 4px; margin-left: 20px">---{{ tab.remarkdate }}</span>
                        </a-col>
                        <a-col :span="6">
                          <span style="margin-top: 4px; margin-left: 20px">{{ tab.nickname }}</span>
                        </a-col>
                      </a-row>
                    </a-col>
                  </a-row>
                </div>
              </div>
              <div v-if="!masterNotesExpand">
                <div v-for="(tab, index) in comments" :key="index" style="margin-bottom: 15px">
                  <a-row type="flex" align="middle">
                    <a-col :span="6">
                      <a-row style="margin-left: -4.5px">
                        <a-col :span="1" style="margin-top: 4px; margin-right: 15px"></a-col>
                        <a-col :span="20" v-if="!tab.demandId">
                          <div style="margin-left: 20px; display: flex; align-items: center">
                            <a-button type="primary" style="margin: 0 10px" @click="editRemark(tab)">编辑 </a-button>
                            <a-button
                              type="primary"
                              style="margin-right: 10px"
                              v-if="tab.flag === true"
                              @click="preservation(tab)"
                              >保存
                            </a-button>
                            <a-button type="primary" style="" @click="removeTab(tab)">删除</a-button>
                          </div>
                        </a-col>
                      </a-row>
                    </a-col>
                    <a-col :span="18">
                      <a-row type="flex" align="middle" style="margin-top: 4px">
                        <a-col :span="12">
                          <span style="margin-top: 4px">
                            <span v-if="tab.flag === false">
                              {{ tab.remarkInfo }}
                            </span>
                            <span v-if="tab.flag === true">
                              <a-input v-model.trim="tab.remarkInfo" @change="onchangeiInput" style="width: 100%" />
                            </span>
                          </span>
                        </a-col>
                        <a-col :span="6">
                          <span style="margin-top: 4px; margin-left: 20px">---{{ tab.remarkdate }}</span>
                        </a-col>
                        <a-col :span="5">
                          <span style="margin-top: 4px; margin-left: 20px">{{ tab.nickname }}</span>
                        </a-col>
                      </a-row>
                    </a-col>
                  </a-row>
                </div>
              </div>
              <a-row style="margin-left: -4.5px; margin-left: 20px">
                <a-col :span="22">
                  <a-row style="margin-left: -4.5px; margin-left: 20px">
                    <a-col :span="1" style="margin-top: 4px; margin-right: 15px"> </a-col>
                    <a-col :span="20">
                      <a-form-item style="width: 100%; margin-left: -55px">
                        <a-textarea style="margin-left: -3px; resize: none" :rows="4" v-model.trim="value" />
                      </a-form-item>
                    </a-col>
                    <a-col :span="2">
                      <a-button type="primary" style="margin-left: 20px" @click="Submission()"> 提交</a-button>
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
              <a-row v-if="comments.length > 8">
                <!---->
                <a-col :span="2" style=""> </a-col>
                <a-col :span="20">
                  <a-form-item label="" style="margin: 20px">
                    <a-button type="primary" @click="masterNotesExpand = !masterNotesExpand">收起/展开</a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="20" style="display: flex">
              <!--//<label style="margin-left: 20px;">新增照片</label>-->
              <div class="clearfix" style="margin-top: 45px; display: flex; margin-left: 42px">
                <a-upload
                  style="margin-left: 20px"
                  :action="uploadUrl"
                  list-type="picture-card"
                  :file-list="fileListMaster"
                  :headers="headers"
                  @preview="handlePreviewMaster"
                  @change="handleChangeMaster"
                >
                  <div>
                    <a-icon type="plus" />
                    <div class="ant-upload-text">新增照片</div>
                  </div>
                </a-upload>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!--订单备注-->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form" selfUpdate="true">
          <a-row>
            <a-col :span="20">
              <div v-if="notesOrderExpand">
                <div v-for="(tab, index) in ordercomments.slice(0, 8)" :key="index" style="margin-top: 15px">
                  <a-row style="margin: 10px">
                    <a-col :span="7">
                      <a-row style="margin-left: -4.5px; margin-left: 20px">
                        <a-col :span="1" style="margin-top: 4px; margin-right: 15px"></a-col>
                        <a-col :span="20">
                          <div style="margin-left: 20px; display: flex; align-items: center">
                            <a-button type="primary" style="margin: 0 10px" @click="editRemark(tab)">编辑 </a-button>
                            <a-button
                              type="primary"
                              style="margin: 0 10px"
                              v-if="tab.flag === true"
                              @click="preservation(tab)"
                              >保存
                            </a-button>
                            <a-button type="primary" @click="removeTab(tab)">删除</a-button>
                          </div>
                        </a-col>
                      </a-row>
                    </a-col>
                    <a-col :span="17">
                      <div style="margin-top: 4px">
                        <span style="margin: 4px 10px; color: #40a9ff">{{ tab.type }} </span>
                        <span style="margin-top: 4px; margin-left: 20px">
                          <span v-if="tab.flag === false">
                            {{ tab.remarkInfo }}
                          </span>
                          <span v-if="tab.flag === true">
                            <a-input v-model.trim="tab.remarkInfo" @change="onchangeiInput" style="width: 100px" />
                          </span>
                        </span>
                        <span style="margin-top: 4px; margin-left: 20px">---{{ tab.remarkdate }}</span>
                        <span style="margin-top: 4px; margin-left: 20px">{{ tab.nickname }}</span>
                      </div>
                    </a-col>
                  </a-row>
                </div>
              </div>
              <div v-if="!notesOrderExpand">
                <div class="orderKeyword" style="margin: 20px">
                  <label style="font-size: 24px; font-weight: bold">订单备注</label>
                </div>
                <div v-for="(tab, index) in ordercomments" :key="index" style="margin-top: 15px">
                  <a-row style="margin: 10px">
                    <a-col :span="7">
                      <a-row style="margin-left: -4.5px; margin-left: 20px">
                        <a-col :span="1" style="margin-top: 4px; margin-right: 15px"></a-col>
                        <a-col :span="20">
                          <div style="margin-left: 20px; display: flex; align-items: center">
                            <a-button type="primary" style="margin: 0 10px" @click="editRemark(tab)">编辑 </a-button>
                            <a-button
                              type="primary"
                              style="margin: 0 10px"
                              v-if="tab.flag === true"
                              @click="preservation(tab)"
                              >保存
                            </a-button>
                            <a-button type="primary" @click="removeTab(tab)">删除</a-button>
                          </div>
                        </a-col>
                      </a-row>
                    </a-col>
                    <a-col :span="17">
                      <div style="margin-top: 4px">
                        <span style="margin: 4px 10px; color: #40a9ff">{{ tab.type }} </span>
                        <span style="margin-top: 4px; margin-left: 20px">
                          <span v-if="tab.flag === false">
                            {{ tab.remarkInfo }}
                          </span>
                          <span v-if="tab.flag === true">
                            <a-input v-model.trim="tab.remarkInfo" @change="onchangeiInput" style="width: 100px" />
                          </span>
                        </span>
                        <span style="margin-top: 4px; margin-left: 20px">---{{ tab.remarkdate }}</span>
                        <span style="margin-top: 4px; margin-left: 20px">{{ tab.nickname }}</span>
                      </div>
                    </a-col>
                  </a-row>
                </div>
              </div>
              <a-row style="margin-left: -4.5px; margin-left: 20px">
                <a-col :span="22">
                  <a-row style="margin-left: -4.5px; margin-left: 20px">
                    <a-col :span="1" style="margin-top: 4px; margin-right: 15px"> </a-col>
                    <a-col :span="20">
                      <a-form-item label="" style="width: 100%; margin-left: -55px">
                        <a-textarea style="resize: none" :rows="4" v-model.trim="ordervalue" />
                      </a-form-item>
                    </a-col>
                    <a-col :span="2" style="display: flex; flex-wrap: wrap">
                      <a-button
                        v-if="addOuterrRemark && addInnerRemark"
                        type="primary"
                        style="margin-bottom: 20px; margin-left: 20px"
                        @click="externalSubmission()"
                        >外部
                      </a-button>
                      <a-button
                        type="primary"
                        style="margin-bottom: 20px; margin-left: 20px"
                        v-if="addOuterrRemark && !addInnerRemark"
                        @click="externalSubmission()"
                        >提交
                      </a-button>
                      <a-button
                        v-if="addInnerRemark"
                        type="primary"
                        style="margin-left: 20px"
                        @click="insideSubmission()"
                        >内部</a-button
                      >
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <a-row v-if="ordercomments.length > 8">
            <!---->
            <a-col :span="2" style=""> </a-col>
            <a-col :span="20">
              <a-form-item label="" style="margin: 0 20px 20px 0">
                <a-button type="primary" @click="notesOrderExpand = !notesOrderExpand">收起/展开</a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!--新增包裹-->
      <a-row style="margin-left: 36px; margin: 0px">
        <a-col :span="2" style="display: flex; justify-content: flex-start; margin-left: 36px; margin-left: 20px">
          <a-button type="primary" icon="plus" @click="addTab()" style="margin: 20px">新增包裹 </a-button>
        </a-col>
        <a-col :span="22"></a-col>
      </a-row>
      <div v-for="(tab, index) in accessoryList" :key="index" style="margin-top: 15px" v-if="accessoryList">
        <a-row style="margin-left: 30px">
          <a-col :span="5">
            <a-form-item style="margin-left: 5px" label="包裹" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model.trim="tab.transportName" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item style="margin-left: 5px" label="快递公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                :getPopupContainer="getPopupContainer"
                style="width: 100%"
                v-model.trim="tab.transportCode"
                :allowClear="true"
              >
                <a-select-option v-for="type in delivery_company" :key="type.dictValue"
                  >{{ type.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item style="margin-left: 5px" label="快递单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model.trim="tab.transportNo" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item style="margin-left: 5px" label="快递备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model.trim="tab.remark" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="4" style="">
            <a-checkbox
              style="border-radius: 50%; margin-left: 5px"
              :checked="tab.isMain"
              @change="onChangeImportant(index, $event)"
              >重要</a-checkbox
            >
            <a-button type="primary" style="margin: 0 10px" @click="removeTab(tab)">删除</a-button>
          </a-col>
        </a-row>
      </div>
      <!--配件信息-->
      <div class="table-page-search-wrapper" v-if="needAccessories == 1">
        <a-form layout="inline" :form="form">
          <div class="orderKeyword" style="margin: 20px 0px">
            <label style="font-size: 24px; font-weight: bold">配件信息</label>
          </div>
          <a-row style="margin-left: 36px; margin: 0px">
            <a-col :span="2" style="display: flex; justify-content: flex-start; margin-left: 36px; margin-left: 20px">
              <a-button @click="showbtn()" icon="plus" type="primary" style="margin: 20px 0">新增配件 </a-button>
            </a-col>
            <a-col :span="22"></a-col>
          </a-row>
          <a-table
            size="default"
            ref="table"
            :scroll="{ x: 1300 }"
            rowKey="accessoryId"
            :columns="columnsAddaccessories"
            :dataSource="loadDataPj"
            :form="form"
            :pagination="false"
          >
            <span slot="action" slot-scope="text, record, index">
              <a @click="handleEdit(record, index)">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm title="是否要删除此行？" @confirm="removeTab(record)">
                <a>删除</a>
              </a-popconfirm>
            </span>
          </a-table>
        </a-form>
      </div>
      <!--安装信息-->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form">
          <div class="orderKeyword">
            <label style="font-size: 24px; font-weight: bold">安装信息</label>
          </div>
          <a-row>
            <a-col :span="6" v-for="(type, index) in installationInfoList" :key="type.id">
              <a-form-item
                :label="type.installationInfoName"
                style="margin-left: 15px"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
              >
                <a-input v-if="type.fieldType == 1" @change="changeinput(index, $event)" />
                <a-select
                  :getPopupContainer="getPopupContainer"
                  v-if="type.fieldType == 0"
                  style="width: 100%"
                  @change="changeselect(index, $event)"
                  :allowClear="true"
                >
                  <a-select-option v-for="tab in type.installTypeValues" :key="tab.dictValue">
                    {{ tab.dictLabel }}
                  </a-select-option>
                </a-select>
                <a-select
                  :getPopupContainer="getPopupContainer"
                  optionFilterProp="children"
                  showSearch
                  style="width: 100%"
                  :filterOption="filterOption"
                  @change="changeselect(index, $event)"
                  :allowClear="true"
                  v-if="type.fieldType == 3"
                >
                  <a-select-option v-for="tab in type.installTypeValues" :key="tab.dictValue">
                    {{ tab.dictLabel }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-row style="padding: 30px; display: flex; flex-direction: row">
                <a-upload
                  :multiple="true"
                  name="file"
                  list-type="picture-card"
                  class="avatar-uploader"
                  :headers="headers"
                  :file-list="clientPic"
                  :action="uploadUrl"
                  @preview="handlePreview"
                  @change="picsalepichandleChange"
                >
                  <a-icon type="upload" />
                  <div class="ant-upload-text">客户照片</div>
                </a-upload>
              </a-row>
            </a-col>
          </a-row>
          <a-row style="padding: 30px">
            <a-col :span="4">
              <a-upload
                name="file"
                :multiple="true"
                list-type="picture"
                accept="video/*"
                class="avatar-uploader"
                :showUploadList="false"
                :headers="headers"
                :action="uploadUrl"
                @change="videosalepichandleChange"
              >
                <a-button> <a-icon type="upload" /> 客户视频 </a-button>
              </a-upload>
            </a-col>
            <div style="display: flex; flex-direction: row; width: 100%">
              <div v-for="(item, i) in clientVideo">
                <video
                  class="video"
                  :key="index"
                  :src="'https://lockan.obs.cn-east-3.myhuaweicloud.com/' + item"
                  controls
                ></video>
                <a-icon type="delete" style="fontsize: 20px" class="img" @click="handleSelect(i)" />
              </div>
              <!--<video style="width: 300px;margin:10px;margin-left:0px"  v-for="item in clientVideo" :key="index" :src="item+'&token='+token" controls></video>-->
            </div>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-affix style="position: fixed; bottom: 8px; left: 40%; z-index: 10">
                <div style="width: 700px">
                  <a-button
                    style="margin-right: 50px; float: left"
                    :loading="editloading"
                    type="primary"
                    @click="orderSubmit()"
                    >提交</a-button
                  >
                  <a-button
                    style="margin-right: 50px; float: left"
                    :loading="editloading"
                    type="primary"
                    @click="editSubmit()"
                    >提交并编辑</a-button
                  >
                  <a-button style="margin-right: 50px; float: left" @click="ordercancel">取消</a-button>
                </div>
              </a-affix>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!--    //添加配件里面的modal-->
      <a-modal v-model="disable" @ok="addAccessories()" title="配件" :width="1200" @cancel="cancelAccessories">
        <a-form :form="formaccessories">
          <a-row>
            <a-col :span="13">
              <a-form-item label="配件信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select
                  :getPopupContainer="getPopupContainer"
                  @change="accessoryChange"
                  v-decorator="['accessoryId', { rules: [{ required: true, message: '选择配件信息!' }] }]"
                  :allowClear="true"
                >
                  <a-select-option v-for="type in EnterpriseAccessory" :key="type.accessoryId">{{
                    type.accessoryName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业配件单价">
                <a-input
                  disabled="disabled"
                  autocomplete="off"
                  v-decorator="['price', { rules: [{ required: true, message: '填写企业配件单价!' }] }]"
                />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
                <a-input-number
                  autocomplete="off"
                  min="1"
                  precision="0.1"
                  v-decorator="['accessoryNum', { rules: [{ required: true, message: '填写数量!' }], initialValue: 1 }]"
                  style="width: 100%"
                  @change="accessoryNumChange"
                />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业配件总金额">
                <a-input
                  disabled="disabled"
                  autocomplete="off"
                  v-decorator="['totalAmount', { rules: [{ required: true, message: '企业配件总金额!' }] }]"
                />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货仓库">
                <a-select
                  :getPopupContainer="getPopupContainer"
                  autocomplete="off"
                  v-decorator="['repositoryName', { rules: [{ required: true, message: '选择发货仓库!' }] }]"
                  @change="repositoryChange"
                  :allowClear="true"
                >
                  <a-select-option v-for="type in queryEnterpriseStock" :key="type.storeName">{{
                    type.storeName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-divider orientation="left"></a-divider>
              <a-checkbox :labelCol="labelCol" :wrapperCol="wrapperCol" :checked="showh" @change="onChangeinfo">
                物流信息</a-checkbox
              >
            </a-col>
          </a-row>
          <a-row v-if="showh">
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货日期">
                <a-date-picker
                  style="width: 251px"
                  @change="onChangeT"
                  format="YYYY-MM-DD HH"
                  v-model.trim="time_list"
                  :allowClear="true"
                />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递公司">
                <a-select
                  :getPopupContainer="getPopupContainer"
                  autocomplete="off"
                  v-decorator="['transportlabel', { rules: [{ required: true, message: '选择快递公司!' }] }]"
                  @change="transportChange"
                >
                  <a-select-option v-for="type in delivery_company" :key="type.dictLabel">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递单号">
                <a-input
                  autocomplete="off"
                  v-decorator="['transportNo', { rules: [{ required: true, message: '选择快递单号!' }] }]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货人">
                <a-input v-decorator="['sendUser']" autocomplete="off" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收货人">
                <a-input v-decorator="['receiveUser']" autocomplete="off" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-input v-decorator="['transportRemark']" autocomplete="off" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <!--代入信息 弹框-->
      <a-modal
        title="查询匹配订单信息"
        style="top: 20px"
        width="75%"
        v-model="removeible"
        :confirmLoading="confirmLoading"
        @ok="confirmOk"
        @cancel="confirmCancel"
      >
        <!--            表格内容-->
        <a-table
          size="default"
          ref="table"
          :scroll="{ x: 1000 }"
          rowKey="orderId"
          :columns="columnsSubstitution"
          :dataSource="this.subList"
          bordered
          :pagination="false"
          :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        >
          <span slot="action" slot-scope="text, record">
            <a @click="handleAdd(record)">选择</a>
          </span>
        </a-table>
      </a-modal>
      <!--订单关联-->
      <a-modal
        title="订单关联"
        style="top: 20px"
        width="75%"
        v-model="relationible"
        :confirmLoading="confirmLoading"
        :footer="null"
        :maskClosable="true"
        @cancel="goorderList"
      >
        <!--            表格内容-->
        <a-table
          :loading="loading2"
          size="default"
          ref="table"
          rowKey="orderId"
          :columns="columnsRelation"
          :dataSource="this.relationList"
          bordered
          :scroll="{ x: 1000 }"
          :pagination="false"
        >
          <span slot="action" slot-scope="text, record">
            <a @click="orderMaster(record)">主订单</a>
            <a-divider type="vertical" v-if="record.orderLevel != '主订单'" />
            <a v-if="record.orderLevel != '主订单'" @click="relation(record)">关联 </a>
          </span>
          <!--<span slot="orderNo" slot-scope="text, record">-->
          <!--<a @click="changeorderNo(record)">{{record.orderNo}}</a>-->
          <!--</span>-->
        </a-table>
      </a-modal>
      <!--填写不完整提醒-->
      <a-modal
        title="填写不完整提醒"
        style="top: 20px"
        v-model="incompleteible"
        :confirmLoading="confirmLoading"
        @ok="incompleteOk"
        :width="950"
        @cancel="confirmCancel"
      >
        <div style="text-align: center">
          <a-icon type="close-circle" style="font-size: 50px; color: #cf1322; margin: 20px" />
        </div>
        <p style="text-align: center; font-size: 24px">信息填写不完整，请填写完整后保存</p>
      </a-modal>
      <!--加急额度-->
      <a-modal title="加急额度" style="top: 20px" v-model="OrderUrgentible" :width="950" footer="">
        <a-form :form="formOrderUrgent">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="本月已使用加急数">
            <a-input disabled="disabled" v-decorator="['usedUrgentNum']" autocomplete="off" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="加急费用">
            <a-input disabled="disabled" v-decorator="['urgentMoney']" autocomplete="off" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="本月可使用加急数">
            <a-input disabled="disabled" v-decorator="['usefulUrgentNum']" autocomplete="off" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="本月总可加急数">
            <a-input disabled="disabled" v-decorator="['totalUrgentNum']" autocomplete="off" />
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
            <a-button type="primary" @click="OrderUrgentCancel" v-if="isUrgentOrder != 0"> 取消加急 </a-button>
            <a-button type="primary" style="margin-left: 20px" @click="OrderUrgentOk" v-if="isUrgentOrder == 0">
              订单加急
            </a-button>
          </a-form-item>
        </a-form>
      </a-modal>
      <a-modal
        title="移除"
        style="top: 20px"
        :width="800"
        v-model="removeOrderible"
        @ok="removeConfirmOk"
        @cancel="confirmCancel"
      >
        <p>确定移除该条信息吗？</p>
      </a-modal>
      <edit-order-model v-if="$store.state.user_type == 1" ref="editordermodel"></edit-order-model>
      <edit-order-model1 v-else ref="editordermodel"></edit-order-model1>
      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
        <img alt="example" style="width: 100%; padding: 10px" :src="previewImage" />
      </a-modal>
    </a-card>
  </a-modal>
</template>

<script>
import ACol from 'ant-design-vue/es/grid/Col'
import _ from 'lodash'
import { getDictMap } from '@/utils/dict'

import {
  getselectAllProvince,
  getfinddictAll,
  getselectCityName,
  getselectAreaName,
  getSelectBrand,
  getSelectModel,
  getList,
  getDxEnterpriseList,
} from '@/api/order/orderList'
import {
  getselectChannel,
  getselectSource,
  getanalysisText,
  getsearchMatchOrder,
  getselectCombox,
  getdemandlist,
  getPiclist,
  getqueryEnterpriseAccessory,
  getqueryEnterpriseStock,
  getqueryEnterpriseAccessoryPrice,
  gettemplatelist,
  getinfoList,
  getaddOrder,
  addOrderRelation,
  getBaseInfoForOrder,
  getcheckOrderUrgent,
  getenterpriseInstallTypes,
  getEnterpriseContactsById,
  gettemplateselectInfo,
  getverificationOrder,
  getSendBackList,
  selectEnterpriseinfo,
} from '@/api/order/NewlyaddedOrderList'
import { STable } from '@/components'
import '@/assets/iconfont/iconfont.css'
import { checkPermission } from '@/utils/permissions'
import pick from 'lodash.pick'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import store from '@/store'
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}

export default {
  name: 'TableList',
  components: {
    ACol,
    STable,
    editOrderModel: () => import('@/views/order/modules/editOrderModel'),
    editOrderModel1: () => import('@/views/order/modules/editOrderModel1'),
  },
  props: {
    step: {
      // 此数据是控制动画快慢的
      type: Number,
      default: 50,
    },
  },
  data() {
    return {
      modelSpecLength: '',
      modelSpecWidth: '',
      dataAll: [],
      orderId22: '',
      clientRequire: '',
      editIndex: 0,
      EnterDisabled: false,
      masterNotesExpand: false,
      notesOrderExpand: false,
      columnsAddaccessories: [
        {
          title: '序号',
          dataIndex: 'no',
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: '操作',

          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '配件名称',
          dataIndex: 'accessoryName',
        },
        {
          title: '数量',
          dataIndex: 'accessoryNum',
        },
        {
          title: '企业配件单价',
          dataIndex: 'price',
        },
        {
          title: '企业配件总金额',
          dataIndex: 'totalAmount',
        },
        {
          title: '发货日期',
          dataIndex: 'deliveryTime',
        },
        {
          title: '快递公司',
          dataIndex: 'transportlabel',
        },
        {
          title: '快递公司',
          className: 'notshow',
          dataIndex: 'transportCode',
        },
        {
          title: '快递单号',
          dataIndex: 'transportNo',
          scopedSlots: { customRender: 'transport' },
        },
        {
          title: '快递状态',
          dataIndex: 'transportStatus',
        },
        {
          title: '发货仓库',
          dataIndex: 'repositoryName',
        },
        {
          title: '发货人',
          dataIndex: 'sendUser',
        },
        {
          title: '收货人',
          dataIndex: 'receiveUser',
        },
      ],
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      store,
      token: Vue.ls.get(ACCESS_TOKEN),
      NewlyaddedOrderListible: false,
      // infoName:'',
      uploadUrl: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=order',
      loading2: false,
      hasCounterVaneOptions: [
        { label: '是', value: 0 },
        { label: '否', value: 1 },
      ],
      showCounterVaneFields: false,
      editloading: false,
      brandinitialValue: '',
      modelinitialValue: '',
      removeTabItem: '',
      addOrderid: '',
      order_demand: '',
      expectinstallTimeible: false,
      timeselect: [
        { value: '07-09', label: '7-9点' },
        { value: '09-11', label: '9-11点' },
        { value: '11-13', label: '11-13点' },
        { value: '13-15', label: '13-15点' },
        { value: '15-17', label: '15-17点' },
        { value: '17-19', label: '17-19点' },
        { value: '19-21', label: '19-21点' },
        { value: '21-07', label: '21-次日7点' },
      ],
      parts: {},
      enterpriseId: '',
      queryEnterpriseAccessoryPrice: '',
      queryEnterpriseStock: [],
      installationInfoList: [],
      // 订单添加配件查询企业可用配件
      EnterpriseAccessory: [],
      provinceCode: '',
      // 查询master_demand要求列表
      demandlist: '',
      // 查询企业要求图片列表
      Piclist: [],
      provinceCodeLis: '',
      selectCombox: [],
      // 寄回要求数据
      sendBackList: [],
      flag: '',
      value: '',
      valueradio: '',
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      ordervalue: '',
      comments: [],
      ordercomments: [],
      subList: '',
      installTime: '',
      // 表头 弹框 // 代入信息弹框的表头
      columnsSubstitution: [
        {
          title: '订单号',
          dataIndex: 'orderNo',
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderTypeName',
          align: 'center',
        },
        {
          title: '订单状态',
          dataIndex: 'status',
          align: 'center',
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
        },
        {
          title: '品牌型号',
          dataIndex: 'brandName',
          align: 'center',
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center',
        },
        {
          title: '师傅姓名',
          dataIndex: 'masterName',
          align: 'center',
        },
      ],
      columnsRelation: [
        {
          title: '操作栏',

          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '状态栏',
          dataIndex: 'orderLevel',
          align: 'center',
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          scopedSlots: { customRender: 'orderNo' },
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderTypeName',
          align: 'center',
        },
        {
          title: '订单状态',
          dataIndex: 'status',
          align: 'center',
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
        },
        {
          title: '品牌型号',
          dataIndex: 'brandName',
          align: 'center',
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center',
        },
        {
          title: '师傅姓名',
          dataIndex: 'masterName',
          align: 'center',
        },
      ],
      removeible: false,
      removeLoading: false,
      resolution: '',
      selectChannel: [],
      selectParts: [], //是否配件随货-下拉
      selectSource: [],
      form: this.$form.createForm(this),
      formaccessories: this.$form.createForm(this),
      formOrderUrgent: this.$form.createForm(this),
      // 付款方式
      pay_type: [],
      // 旧件返厂地址
      address_type: [],
      queryParam: {},
      // 查询型号下拉框
      selectModel: [],
      // 查询品牌下拉框
      selectBrand: [],
      // 字典为安装类型
      installTypes: [],
      List: [],
      // addAccessory: checkPermission('addAccessory'),
      addOuterrRemark: checkPermission('addOuterrRemark'),
      addInnerRemark: checkPermission('addInnerRemark'),
      // 字典为快递公司
      delivery_company: [],
      accessoryList: [],
      installTimeBegin: '',
      installTimeEnd: '',
      // 省
      selectAllProvince: [],
      // 市
      selectCityName: [],
      // 区
      selectAreaName: [],
      arr: {},
      loadDataPj: [],
      expresscompany: [],
      visible: false,
      showh: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      disable: false,
      // isActive: false,
      // 上传1
      previewVisible: false,
      previewImage: '',
      fileList: [{}],
      previewVisibletwo: false,
      previewImagetwo: '',
      fileListtwo: [{}],
      previewVisiblethree: false,
      previewImagethree: '',
      fileListthree: [{}],
      previewVisiblefour: false,
      incompleteible: false,
      relationList: [],
      relationible: false,
      previewImagefour: '',
      fileListfour: [{}],
      sAddaccessories: [
        {
          title: '序号',
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: '操作',

          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '配件名称',
          dataIndex: 'accessoryName',
        },
        {
          title: '数量',
          dataIndex: 'accessoryNum',
        },
        {
          title: '配件单价',
          dataIndex: 'price',
        },
        {
          title: '配件总金额',
          dataIndex: 'totalAmount',
        },
        {
          title: '发货日期',
          dataIndex: 'deliveryTime',
        },
        {
          title: '快递公司',
          dataIndex: 'transportlabel',
        },
        {
          title: '快递单号',
          dataIndex: 'transportNo',
        },
        {
          title: '快递状态',
          dataIndex: 'forbiddenStatus',
        },
        {
          title: '发货仓库',
          dataIndex: 'repositoryName',
        },
        {
          title: '发货人',
          dataIndex: 'sendUser',
        },
        {
          title: '收货人',
          dataIndex: 'receiveUser',
        },
      ],
      selectedRowKeys: [],
      selectedRows: [],
      time_list: '',
      customInfo: [],
      needAccessories: '',
      accessoryEditrecord: '',
      temporarilySettleTime: '',
      OrderUrgentible: false,
      isSmsWarnbool: false,
      isSerialNotice: false,
      factoryStatus: false,
      isMainOrderbool: false,
      isUrgentOrder: 0,
      urgentPrice: '',
      clientPic: [],
      clientVideo: [],
      fileListMaster: [],
      filePathsMaster: [],
      videoState: false,
      spinlogin: false,
      confirmLoading: false,
      accessoriesOptions: [],
    }
  },
  async created() {
    let accessoriesOptions = await getDictMap('accessories_type')
    accessoriesOptions.forEach((value, key) => {
      this.accessoriesOptions.push({ code: key, label: value })
    })
    // console.log(this.accessoriesOptions, 'this.accessoriesOptions');
  },
  mounted() {
    window.init = (res) => {
      this.init(res)
    }
  },
  methods: {
    // 自动识别订单信息
    init(res) {
      console.log(res)
      this.resolution = res.resolution // 地址
      this.addressResolution() // 地址自动解析
      this.form.setFieldsValue({
        // 企业id，要求
        enterpriseId: res.enterpriseId,
        clientRequire: res.clientRequire,
        originalOrderNo: res.originalOrder,
      })
      if (res.orderNotes && res.orderNotes.length > 0) {
        res.orderNotes.forEach((item) => {
          this.ordervalue = item.centent
          if (item.type == 'out') {
            this.externalSubmission()
          } else {
            this.insideSubmission()
          }
        })
      }

      // 企业id联动，设置订单类型
      this.enterpriseChange(res.enterpriseId, res.orderTypeId)
    },
    // 刷新订单号
    getOrderNum() {
      this.spinlogin = true
      this.$axios({
        method: 'get',
        url: '/api/order/order/generateOrderNo',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        this.form.setFieldsValue({
          orderNo: res.data.data,
        })
        this.spinlogin = false
      })
    },
    handleSelect(i) {
      // console.log(this.clientVideo[i])
      this.clientVideo.splice(i, 1)
    },
    onHasCounterVaneChange(value) {
      if (value === 0) {
        this.showCounterVaneFields = true
      } else {
        this.showCounterVaneFields = false
      }
    },

    showcreated() {
      this.clientPic = []
      this.clientVideo = []
      this.fileListMaster = [] // 师傅备注 上传照片
      getselectAllProvince().then((res) => {
        if (res.code === 0) {
          this.selectAllProvince = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
      const dictTypes = ['delivery_company', 'pay_type']
      getfinddictAll({ dictTypes: dictTypes.join() }).then((res) => {
        this.delivery_company = res.delivery_company
        this.pay_type = res.pay_type
      })
      if (this.$store.getters.enterpriseId) {
        // getSelectBrand({enterpriseId:this.$store.getters.enterpriseId}).then(res => {
        //   if (res.code === 0) {
        //     this.selectBrand = res.data;
        //   } else {
        //     this.$message.error(res.msg);
        //   }
        // })
        getenterpriseInstallTypes({ enterpriseId: this.$store.getters.enterpriseId }).then((res) => {
          if (res.code === 0) {
            this.installTypes = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        // await getSelectModel().then(res => {
        //   if (res.code === 0) {
        //     this.selectModel = res.data;
        //   } else {
        //     this.$message.error(res.msg);
        //   }
        // })
      }
      // this.selectSource = [];
      // // 查询信息来源下拉框
      // getselectSource().then(res => {
      //   if (res.code === 0) {
      //     // console.log(res)
      //     this.selectSource = res.data;
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // })
      // 查询购买渠道下拉框
      // this.selectChannel = [];
      // getselectChannel().then(res => {
      //   if (res.code === 0) {
      //     // console.log(res)
      //     this.selectChannel = res.data;
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // })
      this.selectCombox = []
      getDxEnterpriseList({
        type: 0,
      }).then((res) => {
        if (res.code === 0) {
          this.selectCombox = res.data
          // console.log(this.selectCombox)
        } else {
          this.$message.error(res.msg)
        }
      })

      // this.EnterpriseAccessory = [];
      // // 查询配件信息下拉框
      // await getqueryEnterpriseAccessory().then(res => {
      //   if (res.code === 0) {
      //     this.EnterpriseAccessory = res.data;
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // })
    },
    deWeightFour(arr4, obj) {
      console.log(arr4, 'arr4')
      arr4 = arr4.reduce(function (a, b) {
        obj[b.name] ? '' : (obj[b.name] = true && a.push(b))
        return a
      }, [])
      return arr4
    },
    async handlePreviewMaster(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    getImgToBase64(url, callback) {
      // 将图片转换为Base64
      var canvas = document.createElement('canvas')
      var ctx = canvas.getContext('2d')
      var img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function () {
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        var dataURL = canvas.toDataURL('image/png')
        callback(dataURL)
        canvas = null
      }
      img.src = url
    },
    handleChangeMaster({ fileList }) {
      this.fileListMaster = fileList
      console.log(this.fileListMaster)
      if (fileList.length === 0) {
        this.filePathsMaster = []
      } else {
        this.filePathsMaster = []
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].response !== undefined) {
            this.filePathsMaster.push(fileList[i].response.url)
          }
          if (fileList[i].url !== undefined) {
            this.filePathsMaster.push(fileList[i].url)
          }
        }
      }
    },
    // 移除
    removeTab(item) {
      const that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          that.removeTabItem = item
          // this.removeOrderible=true
          const Sub = that.comments.indexOf(that.removeTabItem)
          if (Sub !== -1) {
            // 当没有多余tab时就不再删除
            that.comments.splice(Sub, 1)
          }
          const record = that.loadDataPj.indexOf(that.removeTabItem)
          if (record !== -1) {
            // 当没有多余tab时就不再删除
            that.loadDataPj.splice(record, 1)
          }
          const indexorder = that.ordercomments.indexOf(that.removeTabItem)
          if (indexorder !== -1) {
            // 当没有多余tab时就不再删除
            that.ordercomments.splice(indexorder, 1)
          }
          const index = that.accessoryList.indexOf(that.removeTabItem)
          if (index !== -1) {
            // 当没有多余tab时就不再删除
            that.accessoryList.splice(index, 1)
          }
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    },
    removeConfirmOk() {
      this.removeOrderible = false
    },
    getPopupContainer(trigger) {
      // console.log('trigger', trigger, trigger.parentElement)//型号 5555
      return trigger.parentElement
    },
    changeorderNo(record) {
      // this.$refs.editordermodel.showeditOrder(record.orderId)
      this.$nextTick(() => {
        this.$refs.editordermodel.showeditOrder(record.orderId, '', 1)
      })
    },
    // 新增订单按钮，
    showNewlyaddedOrderList() {
      this.form.resetFields()
      this.showCounterVaneFields = false
      this.isSmsWarnbool = false // 短信提醒
      this.isSerialNotice = false // 条形码
      this.factoryStatus = false // 旧件返厂
      this.isMainOrderbool = false // 重要下单
      this.value = '' // 师傅备注
      this.ordervalue = '' // 订单备注
      this.resolution = '' // 地址解析
      this.order_demand = '' // 下单要求
      this.installTypes = []
      this.List = [] // 订单类型
      this.selectBrand = []
      this.selectModel = []
      this.accessoryList = [] // 包裹
      this.customInfo = [] // 自定义信息
      this.isUrgentOrder = 0 // 订单加急
      this.installationInfoList = [] // 安装信息
      this.loadDataPj = [] // 配件信息
      this.comments = [] // 师傅备注
      this.ordercomments = [] // 订单备注
      this.loading2 = false // 关联订单table loading
      this.editloading = false // 提交并编辑 按钮
      this.NewlyaddedOrderListible = true
      this.showcreated()
      // 企业名称
      this.enterpriseChange(this.$store.getters.enterpriseId)
      // 订单号
      this.$axios({
        method: 'get',
        url: '/api/order/order/generateOrderNo',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        this.form.setFieldsValue({
          orderNo: res.data.data,
        })
      })

      // 企业账号登录 回显
      const StoreUserId = this.$store.getters.enterpriseId
      if (StoreUserId.length != 0) {
        this.$nextTick(() => {
          this.form.setFieldsValue({
            enterpriseId: StoreUserId,
          })
          // this.enterpriseChange(StoreUserId)
          this.EnterDisabled = true
        })
      }
    },
    filterOption(input, option) {
      if (option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },

    picsalepichandleChange(info) {
      this.clientPic = info.fileList
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name}上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    videosalepichandleChange(info) {
      if (info.file.status === 'removed') {
        if (info.file.response.code == 0) {
          const index = this.clientVideo.indexOf(info.file.response.url)
          this.clientVideo.splice(index, 1)
        }
      }
      if (info.file.status === 'done') {
        // info.file.response.url=process.env.VUE_APP_API_BASE_URL+'/dfs/download?fileName='+info.file.response.url
        this.clientVideo.push(info.file.response.url)
        this.$message.success(`${info.file.name}上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    isorderImportant() {
      this.isMainOrderbool = !this.isMainOrderbool
    },
    isSmsWarn() {
      this.isSmsWarnbool = !this.isSmsWarnbool
    },

    isSmsWarn2() {
      this.isSerialNotice = !this.isSerialNotice
    },
    changeFactory() {
      this.factoryStatus = !this.factoryStatus
      if (this.factoryStatus) {
        getEnterpriseContactsById({ enterpriseId: this.enterpriseId }).then((res) => {
          if (res.code === 0) {
            this.address_type = res.data
            res.data.forEach((item) => {
              if (item.defaultStatus == 0) {
                this.form.setFieldsValue({
                  enterpriseAddressId: item.id, // 旧件地址
                })
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
        getSendBackList({ enterpriseId: this.enterpriseId }).then((res) => {
          if (res.code === 0) {
            this.sendBackList = res.data
            if (this.sendBackList.length != 0) {
              this.form.setFieldsValue({
                enterpriseSendBackId: this.sendBackList[0].id,
              })

              this.form.requirement = this.sendBackList[0].requirement
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },

    OrderUrgentOk() {
      this.isUrgentOrder = 1
      this.urgentPrice = this.formOrderUrgent.getFieldValue('urgentMoney')
      this.OrderUrgentible = false
    },
    OrderUrgentCancel() {
      this.isUrgentOrder = 0
      this.OrderUrgentible = false
    },
    isOrderUrgent() {
      if (this.form.getFieldValue('enterpriseId') && this.form.getFieldValue('installType')) {
        getcheckOrderUrgent({
          enterpriseId: this.form.getFieldValue('enterpriseId'),
          installType: this.form.getFieldValue('installType'),
        }).then((res) => {
          if (res.code === 0) {
            this.OrderUrgentible = true
            this.formOrderUrgent.resetFields()
            this.$nextTick(() => {
              this.formOrderUrgent.setFieldsValue(
                pick(res, 'usedUrgentNum', 'urgentMoney', 'usefulUrgentNum', 'totalUrgentNum')
              )
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error('请选择企业名称和安装类别')
      }
      console.log()
    },
    goorderList() {
      this.relationible = false
      this.NewlyaddedOrderListible = false
      this.$emit('ok')
      // this.$router.push({name:'orderList'})
    },
    orderMaster(record) {
      if (record.orderId == this.orderId22) {
      } else {
        this.orderId22 = record.orderId
        this.loading2 = true
        addOrderRelation({ masterOrderId: record.orderId, servantOrderId: this.addOrderid }).then((res) => {
          if (res.code === 0) {
            this.relationible = false
            this.NewlyaddedOrderListible = false
            this.$emit('ok')
            this.loading2 = false
          } else {
            this.$message.error(res.msg)
            this.loading2 = false
            this.orderId22 = ''
          }
        })
      }
    },
    relation(record) {
      if (record.orderId == this.orderId22) {
      } else {
        this.orderId22 = record.orderId
        this.loading2 = true
        addOrderRelation({ masterOrderId: this.addOrderid, servantOrderId: record.orderId }).then((res) => {
          if (res.code === 0) {
            this.relationible = false
            this.NewlyaddedOrderListible = false
            this.$emit('ok')
            this.loading2 = false
          } else {
            this.$message.error(res.msg)
            this.loading2 = false
          }
        })
      }
    },
    changeinput(i, e) {
      this.installationInfoList[i].infoValue = e.target.value
    },
    // onChangeradio(i,e){
    //   this.installationInfoList[i].infoValue=e.target.value
    // },
    changeselect(i, e) {
      this.installationInfoList[i].infoValue = e
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    ordercancel() {
      this.NewlyaddedOrderListible = false
    },
    editSubmit() {
      this.form.validateFieldsAndScroll((err, values) => {
        for (var i = 0; i < this.customInfo.length; i++) {
          if (this.customInfo.length > 0) {
            values.firstName = this.customInfo[0]
          }
          if (this.customInfo.length > 1) {
            values.secondName = this.customInfo[1]
          }
          if (this.customInfo.length > 2) {
            values.thirdName = this.customInfo[2]
          }
        }
        const arr = []
        this.fileListMaster.forEach((item) => {
          if (item.url) {
            arr.push(item.url)
          } else {
            arr.push(item.response.url)
          }
        })
        values.masterRequirePic = arr
        values.installTime = this.installTime
        values.transportList = this.accessoryList
        values.masterRemark = this.comments
        values.orderRemark = this.ordercomments
        values.accessoryList = this.loadDataPj
        values.installCustomize = this.installationInfoList
        values.isUrgentOrder = this.isUrgentOrder
        values.isMainOrder = this.isMainOrderbool ? '1' : '0'
        values.isSmsWarn = this.isSmsWarnbool ? '1' : '0'
        values.isSerialNotice = this.isSerialNotice ? '1' : '0'
        values.factoryStatus = this.factoryStatus ? '1' : '0'
        values.urgentPrice = this.urgentPrice
        const arrPic = []
        this.clientPic.forEach((tab) => {
          if (tab.response) {
            arrPic.push(tab.response.url)
          } else {
            arrPic.push(tab.url)
          }
        })
        if (this.ordervalue) {
          this.externalSubmission()
        }
        if (this.value) {
          this.Submission()
        }
        // console.log( this.clientPic,arrPic )
        values.clientPic = arrPic
        // console.log( values.clientPic )
        values.clientVideo = this.clientVideo
        values.urgentOrderNum = this.formOrderUrgent.getFieldValue('usefulUrgentNum')
        if (!err) {
          this.editloading = true
          getverificationOrder(values).then((res) => {
            if (res.code === 0) {
              getaddOrder(values).then((res) => {
                if (res.code === 0) {
                  this.addOrderid = res.data
                  this.NewlyaddedOrderListible = false
                  this.$emit('ok')
                  this.$nextTick(() => {
                    this.$refs.editordermodel.showeditOrder(this.addOrderid, '', 1)
                  })
                } else {
                  this.$message.error(res.msg)
                  this.editloading = false
                }
              })
            } else {
              this.$message.error(res.msg)
              this.editloading = false
            }
          })
        } else {
          this.incompleteible = true
          this.editloading = false
        }
      })
    },
    orderSubmit(e) {
      // e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        console.log(values, 11111111111111111111)
        for (var i = 0; i < this.customInfo.length; i++) {
          if (this.customInfo.length > 0) {
            values.firstName = this.customInfo[0]
          }
          if (this.customInfo.length > 1) {
            values.secondName = this.customInfo[1]
          }
          if (this.customInfo.length > 2) {
            values.thirdName = this.customInfo[2]
          }
        }
        const arr = []
        this.fileListMaster.forEach((item) => {
          if (item.url) {
            arr.push(item.url)
          } else {
            arr.push(item.response.url)
          }
        })
        if (this.ordervalue) {
          this.externalSubmission()
        }
        if (this.value) {
          this.Submission()
        }
        values.masterRequirePic = arr
        values.installTime = this.installTime
        values.requirement = this.form.requirement
        values.transportList = this.accessoryList
        values.masterRemark = this.comments
        values.orderRemark = this.ordercomments
        values.accessoryList = this.loadDataPj
        values.installCustomize = this.installationInfoList
        values.isUrgentOrder = this.isUrgentOrder
        values.isMainOrder = this.isMainOrderbool ? '1' : '0'
        values.isSmsWarn = this.isSmsWarnbool ? '1' : '0'
        values.isSerialNotice = this.isSerialNotice ? '1' : '0'
        values.factoryStatus = this.factoryStatus ? '1' : '0'
        values.urgentPrice = this.urgentPrice
        const arrPic = []
        this.clientPic.forEach((tab) => {
          if (tab.response) {
            arrPic.push(tab.response.url)
          } else {
            arrPic.push(tab.url)
          }
        })
        // console.log( this.clientPic,arrPic )
        values.clientPic = arrPic
        // values.clientPic =this.clientPic
        values.clientVideo = this.clientVideo
        values.urgentOrderNum = this.formOrderUrgent.getFieldValue('usefulUrgentNum')
        // console.log(values)
        if (values.isCounterVane === 1) {
          values.counterVaneLength = 0
          values.counterVaneWidth = 0
        }
        if (!err) {
          this.editloading = true
          getverificationOrder(values).then((res) => {
            if (res.code === 0) {
              getaddOrder(values).then((res) => {
                if (res.code === 0) {
                  this.addOrderid = res.data
                  getsearchMatchOrder({
                    clientAddress: this.form.getFieldValue('clientAddress'),
                    clientPhone: this.form.getFieldValue('clientPhone'),
                    installType: this.form.getFieldValue('installType'),
                    orderId: this.addOrderid,
                  }).then((res) => {
                    this.relationList = res.data
                    if (this.relationList.length <= 0) {
                      this.$message.success('新增成功')
                      this.NewlyaddedOrderListible = false
                      this.$emit('ok')
                    } else {
                      this.relationible = true
                    }
                  })
                } else {
                  this.$message.error(res.msg)
                  this.editloading = false
                }
              })
            } else {
              this.$message.error(res.msg)
              this.editloading = false
            }
          })
        } else {
          this.incompleteible = true
          this.editloading = false
        }
      })
    },
    // 发货仓库
    async repositoryChange(e) {
      this.queryEnterpriseStock.forEach((item) => {
        if (item.storeName == e) {
          this.parts.repositoryId = item.storeId
        }
      })
    },
    async transportChange(e) {
      this.delivery_company.forEach((item) => {
        if (item.dictLabel == e) {
          this.parts.transportCode = item.dictValue
        }
      })
    },
    // 配件信息
    async accessoryChange(e) {
      const accessoryNum = this.formaccessories.getFieldValue('accessoryNum')
      // 查询企业要求列表
      this.queryEnterpriseAccessoryPrice = ''
      await getqueryEnterpriseAccessoryPrice({ accessoryId: e, enterpriseId: this.enterpriseId }).then((res) => {
        if (res.code === 0) {
          setTimeout(() => {
            this.formaccessories.setFieldsValue({
              price: res.data.price,
            })
            this.accessoryNumChange(accessoryNum)
          }, 100)
          this.parts.accessoryType = res.data.accessoryType
          this.parts.accessorySpecification = res.data.accessorySpecification
          this.parts.accessoryCategory = res.data.accessoryCategory
          this.parts.accessoryName = res.data.accessoryName
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 数量变化时
    async accessoryNumChange(value) {
      const amount = this.formaccessories.getFieldValue('price')
      this.formaccessories.setFieldsValue({
        totalAmount: (amount - 0) * (value - 0),
      })
      if (this.formaccessories.getFieldValue('accessoryId') && this.enterpriseId && value) {
        this.queryEnterpriseStock = []
        await getqueryEnterpriseStock({
          accessoryId: this.formaccessories.getFieldValue('accessoryId'),
          enterpriseId: this.enterpriseId,
          useNum: value,
        }).then((res) => {
          if (res.code === 0) {
            this.queryEnterpriseStock = []
            this.queryEnterpriseStock = res.data.filter((item) => item.storeName)
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error('请选择配件，企业名称，配件数量不能为空')
      }
    },
    // 寄回要求下拉框改变
    sendBackListChange(e) {
      this.form.requirement = this.sendBackList.find((v) => v.id === e).requirement
    },
    // 企业  下来框改变时
    enterpriseChange(e, orderTypeId = '') {
      console.log(e, orderTypeId)
      if (e) {
        this.enterpriseId = e
        this.form.setFieldsValue({
          installType: '',
          orderType: '', // 订单类型
          brandId: '',
          modelId: '',
          enterpriseSendBackId: '', // requirement
          requirement: '', // 寄回要求
          infoSourceId: '', // 信息来源
          buyChannelId: '', // 购买渠道
          enterpriseAddressId: '', // 旧件地址
        })
        this.order_demand = ''
        // this.demandlist=[]
        // this.comments = this.comments.filter((item) => ! item.demandId);
        getEnterpriseContactsById({ enterpriseId: e }).then((res) => {
          if (res.code === 0) {
            this.address_type = res.data
            res.data.forEach((item) => {
              if (item.defaultStatus == 0) {
                this.form.setFieldsValue({
                  enterpriseAddressId: item.id, // 旧件地址
                })
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
        getSendBackList({ enterpriseId: e }).then((res) => {
          if (res.code === 0) {
            this.sendBackList = res.data
            if (this.sendBackList.length != 0) {
              this.form.setFieldsValue({
                enterpriseSendBackId: this.sendBackList[0].id,
              })
              this.form.requirement = this.sendBackList[0].requirement
            }
          } else {
            this.$message.error(res.msg)
          }
        })
        getenterpriseInstallTypes({ enterpriseId: e }).then((res) => {
          if (res.code === 0) {
            this.installTypes = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        getBaseInfoForOrder({ enterpriseId: e }).then((res) => {
          if (res.code === 0) {
            // console.log('aaaa',res.data)
            this.needAccessories = res.data.needAccessories
            this.customInfo = res.data.customInfo
            this.enterpriseInstallTypes = res.data.enterpriseInstallTypes
            this.$nextTick(() => {
              this.form.setFieldsValue({
                installType: res.data.defaultInstallType,
                payType: res.data.payType,
              })
              this.installChange(res.data.defaultInstallType, orderTypeId)
            })
            // this.List = [];
            // getList(res.data.defaultInstallType).then(res => {
            //   if (res.code === 0) {
            //     this.List = res.rows;
            //     if(this.List.length>0){
            //       this.form.setFieldsValue({
            //         orderType: this.List[0].orderTypeId,
            //       })
            //       // 第一次
            //       this.orderChange(this.List[0].orderTypeId)
            //     }
            //
            //   } else {
            //     this.$message.error(res.msg);
            //   }
            // })
          } else {
            this.$message.error(res.msg)
          }
        })
        // 查询企业要求列表
        this.queryEnterpriseStock = []
        getqueryEnterpriseStock({
          accessoryId: this.parts.accessoryList,
          enterpriseId: e,
          useNum: this.parts.accessoryNum,
        }).then((res) => {
          if (res.code === 0) {
            this.queryEnterpriseStock = []
            this.queryEnterpriseStock = res.data.filter((item) => item.storeName)
            // console.log(this.queryEnterpriseStock)
          } else {
            this.$message.error(res.msg)
          }
        })
        // this.EnterpriseAccessory = [];
        // await getqueryEnterpriseAccessory({brandId: this.form.getFieldValue("brandId"),modelId: this.form.getFieldValue("modelId"),installType: this.form.getFieldValue("installType"), enterpriseId: e}).then(res => {
        //   if (res.code === 0) {
        //     this.EnterpriseAccessory = res.data;
        //
        //   } else {
        //     this.$message.error(res.msg);
        //   }
        // })
        // this.selectBrand = [];
        // // 查询品牌下拉框
        // await getSelectBrand({installType: this.form.getFieldValue("installType"), enterpriseId: e}).then(res => {
        //   if (res.code === 0) {
        //     this.selectBrand = res.data;
        //     if(this.selectBrand.length>0){
        //       this.form.setFieldsValue({
        //         brandId: this.selectBrand[0].brandId,
        //       })
        //       this.changeBrandName(this.selectBrand[0].brandId)
        //     }
        //   } else {
        //     this.$message.error(res.msg);
        //   }
        // })
        // 查询型号下拉框
        // this.selectModel = [];
        // await getSelectModel({
        //   installType: this.form.getFieldValue("installType"),
        //   enterpriseId: e,
        //   brandId: this.form.getFieldValue("brandId")
        // }).then(res => {
        //   if (res.code === 0) {
        //     this.selectModel = res.data;
        //     if(this.selectModel.length>0) {
        //       this.form.setFieldsValue({
        //         modelId: this.selectModel[0].modelId,
        //       })
        //       // 第一次
        //       this.changeModelName(this.selectModel[0].modelId)
        //     }
        //
        //     // console.log(this.modelinitialValue)
        //   } else {
        //     this.$message.error(res.msg);
        //   }
        // })
        // this.selectSource = [];
        // // 查询信息来源下拉框
        // await getselectSource({installType: this.form.getFieldValue("installType"), enterpriseId: e}).then(res => {
        //   if (res.code === 0) {
        //     // console.log(res)
        //     this.selectSource = res.data;
        //   } else {
        //     this.$message.error(res.msg);
        //   }
        // })
        // // 查询购买渠道下拉框
        // this.selectChannel = [];
        // await getselectChannel({installType: this.form.getFieldValue("installType"), enterpriseId: e}).then(res => {
        //   if (res.code === 0) {
        //     // console.log(res)
        //     this.selectChannel = res.data;
        //   } else {
        //     this.$message.error(res.msg);
        //   }
        // })
      }
    },
    // 安装类别框改变时
    async installChange(e, orderTypeId = '') {
      console.log(e, orderTypeId)
      this.form.setFieldsValue({
        orderType: '',
        brandId: '',
        modelId: '',
        infoSourceId: '',
        buyChannelId: '',
      })
      this.enterpriseInstallTypes.forEach((item) => {
        if (e == item.installationTypeCode) {
          if (item.smsFlag) {
            if (item.smsFlag == 0) {
              this.isSmsWarnbool = false
            } else {
              this.isSmsWarnbool = true
            }
          } else {
            this.isSmsWarnbool = false
          }

          if (item.serialNoFlag) {
            if (item.serialNoFlag == 0) {
              this.isSerialNotice = false
            } else {
              this.isSerialNotice = true
            }
          } else {
            this.isSerialNotice = false
          }
        }
      })
      this.selectBrand = []
      this.selectSource = []
      this.selectChannel = []
      selectEnterpriseinfo({ installType: e, enterpriseId: this.enterpriseId })
        .then((res) => {
          if (res.code === 0) {
            this.selectBrand = res.data.brand
            if (this.selectBrand.length > 0) {
              this.$nextTick(() => {
                this.form.setFieldsValue({
                  brandId: this.selectBrand[0].brandId,
                })
              })
            }
            this.selectSource = res.data.source
            this.selectChannel = res.data.channel
          }
        })
        .then((res) => {
          getSelectModel({
            installType: e,
            enterpriseId: this.enterpriseId,
            brandId: this.form.getFieldValue('brandId'),
          }).then((res) => {
            if (res.code === 0) {
              this.selectModel = res.data
              if (this.selectModel.length > 0) {
                this.$nextTick(() => {
                  this.form.setFieldsValue({
                    modelId: this.selectModel[0].modelId,
                  })
                  this.changeModelName(this.selectModel[0].modelId)
                })
              }
            } else {
              this.$message.error(res.msg)
            }
          })
        })
      this.List = []
      getList(e).then((res) => {
        if (res.code === 0) {
          this.List = res.rows
          if (this.List.length > 0) {
            this.$nextTick(() => {
              this.form.setFieldsValue({
                orderType: orderTypeId || this.List[0].orderTypeId,
              })
              this.orderChange(this.List[0].orderTypeId)
            })
          }
        } else {
          this.$message.error(res.msg)
        }
      })
      this.selectModel = []
      // this.EnterpriseAccessory = [];
      // // 查询配件信息下拉框
      // await getqueryEnterpriseAccessory({brandId: this.form.getFieldValue("brandId"),modelId:
      //     this.form.getFieldValue("modelId"),installType: e, enterpriseId: this.enterpriseId}).then(res => {
      //   if (res.code === 0) {
      //     this.EnterpriseAccessory = res.data;
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // })
      // getSelectBrand({installType: e, enterpriseId: this.enterpriseId}).then(res => {
      //   if (res.code === 0) {
      //     this.selectBrand = res.data;
      //     if(this.selectBrand.length>0){
      //       this.form.setFieldsValue({
      //         brandId: this.selectBrand[0].brandId,
      //       })
      //     }
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // })
      // // 查询信息来源下拉框
      // getselectSource({installType: e, enterpriseId: this.enterpriseId}).then(res => {
      //   if (res.code === 0) {
      //     // console.log(res)
      //     this.selectSource = res.data;
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // })
      // getselectChannel({installType: e, enterpriseId: this.enterpriseId}).then(res => {
      //   if (res.code === 0) {
      //     this.selectChannel = res.data;
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // })
    },
    // 订单类型  下来框改变时
    async orderChange(e) {
      // 安装信息
      gettemplateselectInfo({ orderType: e, installType: this.form.getFieldValue('installType') }).then((res) => {
        // console.log(res)
        if (res.code === 0) {
          if (res.data) {
            if (res.data != '无模板可用') {
              if (res.data.installationInfoList.length > 0) {
                this.installationInfoList = res.data.installationInfoList
              } else {
                this.installationInfoList = []
              }
            } else {
              this.installationInfoList = []
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      })
      // 查询品牌下拉框
      let modelId = this.form.getFieldValue('modelId')
      modelId = modelId || '1'
      getdemandlist({
        demandType: 'create_order_demand',
        model: modelId,
        orderType: e,
        enterpriseId: this.enterpriseId,
      }).then((res) => {
        if (res.code === 0) {
          this.order_demand = res.data
        } else {
          this.$message.error(res.msg)
        }
      })

      // 查询企业要求列表
      // await getdemandlist({  demandType:'master_demand',model:modelId,orderType:e
      //   , enterpriseId:this.enterpriseId}).then(res => {
      //   if (res.code === 0) {
      //     this.demandlist = res.data.demandList.master_demand;
      //     let that = this
      //     if(this.demandlist){
      //       this.demandlist.forEach(tab=>{
      //         that.comments = that.comments.filter((item) => tab.demandId != item.demandId);
      //       })
      //     }
      //     if(this.demandlist){
      //       this.demandlist.forEach(item=>{
      //         item.remarkInfo=item.demandContent
      //         item.flag=false
      //         item.remarkdate=item.updateTime
      //         item.nickname=item.updateBy
      //       })
      //       this.comments=[...this.comments,...this.demandlist]
      //
      //     }
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // })
      getPiclist({ picType: 'master_demand', model: modelId, orderType: e, enterpriseId: this.enterpriseId }).then(
        (res) => {
          if (res.code === 0) {
            this.fileListMaster = []
            const that = this
            let PhotoArr = []
            PhotoArr = res.data.master_demand
            const fileListMasterArr = []
            if (res.data.master_demand) {
              that.fileListMaster = []
              PhotoArr.forEach((pic) => {
                fileListMasterArr.push(pic.picId)
                that.getImgToBase64(
                  process.env.VUE_APP_API_BASE_URL +
                    '/dfs/download?fileName=' +
                    pic.picPath +
                    '&token=' +
                    Vue.ls.get(ACCESS_TOKEN),
                  function (data) {
                    that.fileListMaster.push({
                      uid: pic.picId,
                      thumbUrl: data,
                      url: pic.picPath,
                    })
                  }
                )
              })
              const PhotoArr2 = []
              let uniqueArr = this.unique(fileListMasterArr)
              for (let s = 0; s < uniqueArr.length; s++) {
                for (let k = 0; k < that.fileListMaster.length; k++) {
                  if (uniqueArr[s] == that.fileListMaster[k].uid) {
                    PhotoArr2.push(that.fileListMaster[k])
                    uniqueArr = uniqueArr.splice(s, 1)
                    s--
                    console.log(this.unique(fileListMasterArr).length)
                  }
                }
              }
              that.fileListMaster = PhotoArr2
            }
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    // 品牌框改变时
    changeBrandName(e) {
      this.form.setFieldsValue({
        modelId: '',
      })
      // this.EnterpriseAccessory = [];
      // // 查询配件下拉框
      // await getqueryEnterpriseAccessory({brandId: e,modelId: this.form.getFieldValue("modelId"),installType:
      //     this.form.getFieldValue("installType"), enterpriseId:this.enterpriseId}).then(res => {
      //   if (res.code === 0) {
      //     this.EnterpriseAccessory = res.data;
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // })
      this.selectModel = []
      getSelectModel({
        installType: this.form.getFieldValue('installType'),
        enterpriseId: this.enterpriseId,
        brandId: e,
      }).then((res) => {
        if (res.code === 0) {
          this.selectModel = res.data
          if (this.selectModel.length > 0) {
            this.form.setFieldsValue({
              modelId: this.selectModel[0].modelId,
            })
            this.changeModelName(this.selectModel[0].modelId)
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    updateModelSpecs(modelId) {
      if (modelId && this.selectModel && this.selectModel.length > 0) {
        const model = this.selectModel.find((item) => item.modelId === modelId)
        if (model) {
          this.modelSpecLength = model.specLength
          this.modelSpecWidth = model.specWidth
        } else {
          this.modelSpecLength = ''
          this.modelSpecWidth = ''
        }
      } else {
        this.modelSpecLength = ''
        this.modelSpecWidth = ''
      }
    },
    // 型号框改变时
    async changeModelName(e) {
      console.log('型号', 5555)
      this.updateModelSpecs(e)
      if (this.form.getFieldValue('orderType') || e) {
        getPiclist({
          picType: 'master_demand',
          model: e,
          orderType: this.form.getFieldValue('orderType'),
          enterpriseId: this.enterpriseId,
        }).then((res) => {
          if (res.code === 0) {
            this.fileListMaster = []
            const that = this
            let PhotoArr = []
            PhotoArr = res.data.master_demand
            const fileListMasterArr = []
            if (res.data.master_demand) {
              PhotoArr.forEach((pic) => {
                fileListMasterArr.push(pic.picId)
                that.getImgToBase64(
                  process.env.VUE_APP_API_BASE_URL +
                    '/dfs/download?fileName=' +
                    pic.picPath +
                    '&token=' +
                    Vue.ls.get(ACCESS_TOKEN),
                  function (data) {
                    that.fileListMaster.push({
                      uid: pic.picId,
                      thumbUrl: data,
                      url: pic.picPath,
                    })
                  }
                )
              })
              const PhotoArr2 = []
              let uniqueArr = this.unique(fileListMasterArr)
              for (let s = 0; s < uniqueArr.length; s++) {
                for (let k = 0; k < that.fileListMaster.length; k++) {
                  if (uniqueArr[s] == that.fileListMaster[k].uid) {
                    PhotoArr2.push(that.fileListMaster[k])
                    uniqueArr = uniqueArr.splice(s, 1)
                    s--
                    console.log(this.unique(fileListMasterArr).length)
                  }
                }
              }
              // console.log(this.unique(fileListMasterArr),'this.unique(fileListMasterArr)')
              // console.log(PhotoArr2,'PhotoArr2')
              that.fileListMaster = PhotoArr2
            }
          } else {
            this.$message.error(res.msg)
          }
        })
        // 查询企业下单要求列表
        await getdemandlist({
          demandType: 'create_order_demand',
          model: e,
          orderType: this.form.getFieldValue('orderType'),
          enterpriseId: this.enterpriseId,
        }).then((res) => {
          if (res.code === 0) {
            this.order_demand = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    preservation(item) {
      const Sub = this.comments.indexOf(item)
      if (Sub !== -1) {
        this.comments[Sub].flag = false
      }
      const index = this.ordercomments.indexOf(item)
      if (index !== -1) {
        this.ordercomments[index].flag = false
      }
    },
    onChanginstallTimeible(value) {
      if (value) {
        this.expectinstallTimeible = true
      } else {
        this.expectinstallTimeible = false
      }
    },
    onChangerangepicker(date, dateString) {
      // console.log(dateString)
      this.installTime = dateString
      if (dateString) {
        this.expectinstallTimeible = true
      } else {
        this.expectinstallTimeible = false
      }
    },
    // 编辑
    editRemark(item) {
      const Sub = this.comments.indexOf(item)
      if (Sub !== -1) {
        this.comments[Sub].flag = true
      }
      const index = this.ordercomments.indexOf(item)
      console.log(index)
      if (index !== -1) {
        this.ordercomments[index].flag = true
      }
    },
    // 获取值 文本框的值
    // handleChangeTextarea(e) {
    //   this.value = this.form.getFieldValue("remarkType")
    // },
    // 获取值 文本框的值
    // ChangeorderTextarea(e) {
    //    this.ordervalue = this.form.getFieldValue("orderRemark")
    //
    //  },
    // 提交
    Submission() {
      var nickname = this.$store.getters.nickname
      // console.log(nickname)
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hour = date.getHours()
      var minute = date.getMinutes()
      var second = date.getSeconds()
      var remarkdate = `${year}-${month}-${day} ${hour}:${minute}:${second}`
      if (this.value) {
        console.log(this.value)
        if (this.value.trim()) {
          this.comments.push({
            remarkInfo: this.value,
            flag: false,
            remarkdate: remarkdate,
            nickname: nickname,
          })
          this.value = ''
          this.form.resetFields('remarkType')
        } else {
          this.$message.error('请填写备注内容')
        }
      } else {
        this.$message.error('请填写备注内容')
      }
    },
    // 提交
    externalSubmission() {
      var nickname = this.$store.getters.nickname
      // console.log(nickname)
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hour = date.getHours()
      var minute = date.getMinutes()
      var second = date.getSeconds()
      var remarkdate = `${year}-${month}-${day} ${hour}:${minute}:${second}`
      if (this.ordervalue) {
        if (this.ordervalue.trim()) {
          this.ordercomments.push({
            remarkInfo: this.ordervalue,
            flag: false,
            type: '外部',
            remarkType: 1,
            remarkdate: remarkdate,
            nickname: nickname,
          })
          this.ordervalue = ''
          this.form.resetFields('orderRemark')
        } else {
          this.$message.error('请填写备注内容')
        }
      } else {
        this.$message.error('请填写备注内容')
      }
    },
    insideSubmission() {
      var nickname = this.$store.getters.nickname
      console.log(nickname)
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hour = date.getHours()
      var minute = date.getMinutes()
      var second = date.getSeconds()
      var remarkdate = `${year}-${month}-${day} ${hour}:${minute}:${second}`
      if (this.ordervalue) {
        if (this.ordervalue.trim()) {
          this.ordercomments.push({
            remarkInfo: this.ordervalue,
            flag: false,
            type: '内部',
            remarkType: 0,
            remarkdate: remarkdate,
            nickname: nickname,
          })
          this.ordervalue = ''
          this.form.resetFields('orderRemark')
        } else {
          this.$message.error('请填写备注内容')
        }
      } else {
        this.$message.error('请填写备注内容')
      }
    },
    // 代入信息 table数据
    async substituteInformation() {
      this.removeible = true
      ;(this.selectedRowKeys = []),
        await getsearchMatchOrder({
          clientAddress: this.form.getFieldValue('clientAddress'),
          clientPhone: this.form.getFieldValue('clientPhone'),
          installType: this.form.getFieldValue('installType'),
        }).then((res) => {
          if (res.code === 0) {
            this.subList = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    async changePhone(e) {
      if (e.target.value.length == 11) {
        await getsearchMatchOrder({
          clientPhone: e.target.value,
        }).then((res) => {
          if (res.code === 0) {
            if (res.data.length > 0) {
              this.$message.success('有关联信息')
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    async changeAddress(e) {
      await getsearchMatchOrder({
        clientAddress: e.target.value,
      }).then((res) => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            this.$message.success('有关联信息')
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 表格弹框确实时
    async confirmOk() {
      if (this.selectedRows.length == 1) {
        this.removeible = false
        this.enterpriseId = this.selectedRows[0].enterpriseId
        await getBaseInfoForOrder({ enterpriseId: this.enterpriseId }).then((res) => {
          if (res.code === 0) {
            this.enterpriseInstallTypes = res.data.enterpriseInstallTypes
            for (var i = 0; i < res.data.enterpriseInstallTypes.length; i++) {
              if (res.data.defaultInstallType == res.data.enterpriseInstallTypes[i].installationTypeCode) {
                if (res.data.enterpriseInstallTypes[i].smsFlag == 0) {
                  this.isSmsWarnbool = false
                } else {
                  this.isSmsWarnbool = true
                }
                if (res.data.enterpriseInstallTypes[i].serialNoFlag == 0) {
                  this.isSerialNotice = false
                } else {
                  this.isSerialNotice = true
                }
              }
            }
            this.form.setFieldsValue({
              installType: res.data.defaultInstallType,
              payType: res.data.payType,
            })
            this.customInfo = res.data.customInfo
            this.List = []
            getList(res.data.defaultInstallType).then((res) => {
              if (res.code === 0) {
                this.List = res.rows
                if (this.List.length > 0) {
                  this.form.setFieldsValue({
                    orderType: this.List[0].orderTypeId,
                  })
                  // 第一次
                  this.orderChange(this.List[0].orderTypeId)
                }
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
        // 市
        getselectCityName({ provinceCode: this.selectedRows[0].provinceCode }).then((res) => {
          if (res.code === 0) {
            this.selectCityName = res.rows
          } else {
            this.$message.error(res.msg)
          }
        })
        // 区
        getselectAreaName({ cityCode: this.selectedRows[0].cityCode }).then((res) => {
          if (res.code === 0) {
            this.selectAreaName = res.rows
          } else {
            this.$message.error(res.msg)
          }
        })
        // 品牌
        await getSelectBrand({
          installType: this.selectedRows[0].installType,
          enterpriseId: this.selectedRows[0].enterpriseId,
        }).then((res) => {
          if (res.code === 0) {
            this.selectBrand = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        // 订单类型
        getenterpriseInstallTypes({ enterpriseId: this.selectedRows[0].enterpriseId }).then((res) => {
          if (res.code === 0) {
            this.installTypes = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        // 品牌
        this.selectModel = []
        getSelectModel({
          installType: this.selectedRows[0].installType,
          enterpriseId: this.selectedRows[0].enterpriseId,
          brandId: this.selectedRows[0].brandId,
        }).then((res) => {
          if (res.code === 0) {
            this.selectModel = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        // 配件信息
        this.EnterpriseAccessory = []
        getqueryEnterpriseAccessory({
          brandId: this.selectedRows[0].brandId,
          modelId: this.selectedRows[0].modelId,
          installType: this.selectedRows[0].installType,
          enterpriseId: this.selectedRows[0].enterpriseId,
        }).then((res) => {
          if (res.code === 0) {
            this.EnterpriseAccessory = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        // 订单类型
        // this.List = [];
        // await getList(this.selectedRows[0].installType).then(res => {
        //   if (res.code === 0) {
        //     this.List = res.rows;
        //     if(this.List.length>0){
        //       this.form.setFieldsValue({
        //         orderType: this.List[0].orderTypeId,
        //       })
        //       this.orderChange(this.List[0].orderTypeId)
        //     }
        //   } else {
        //     this.$message.error(res.msg);
        //   }
        // })
        // 是否配件随货
        this.selectParts = []
        // await getSelectParts().then(res => {
        //   if (res.code === 0) {
        //     this.selectParts = res.data
        //   } else {
        //     this.$message.error(res.msg)
        //   }
        // })

        this.selectSource = []
        // 查询信息来源下拉框
        await getselectSource({
          installType: this.selectedRows[0].installType,
          enterpriseId: this.selectedRows[0].enterpriseId,
        }).then((res) => {
          if (res.code === 0) {
            this.selectSource = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        // 查询购买渠道下拉框
        this.selectChannel = []
        await getselectChannel({
          installType: this.selectedRows[0].installType,
          enterpriseId: this.selectedRows[0].enterpriseId,
        }).then((res) => {
          if (res.code === 0) {
            this.selectChannel = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        let modelId = this.selectedRows[0].modelId
        modelId = modelId || '1'
        getdemandlist({
          demandType: 'create_order_demand',
          model: modelId,
          orderType: this.selectedRows[0].installType,
          enterpriseId: this.selectedRows[0].enterpriseId,
        }).then((res) => {
          if (res.code === 0) {
            this.order_demand = res.data
          } else {
            this.$message.error(res.msg)
          }
        })

        getPiclist({
          picType: 'master_demand',
          model: modelId,
          orderType: this.selectedRows[0].installType,
          enterpriseId: this.selectedRows[0].enterpriseId,
        }).then((res) => {
          if (res.code === 0) {
            this.fileListMaster = []
            const that = this
            let PhotoArr = []
            PhotoArr = res.data.master_demand
            const fileListMasterArr = []
            if (res.data.master_demand) {
              that.fileListMaster = []
              PhotoArr.forEach((pic) => {
                fileListMasterArr.push(pic.picId)
                that.getImgToBase64(
                  process.env.VUE_APP_API_BASE_URL +
                    '/dfs/download?fileName=' +
                    pic.picPath +
                    '&token=' +
                    Vue.ls.get(ACCESS_TOKEN),
                  function (data) {
                    that.fileListMaster.push({
                      uid: pic.picId,
                      thumbUrl: data,
                      url: pic.picPath,
                    })
                  }
                )
              })
              const PhotoArr2 = []
              let uniqueArr = this.unique(fileListMasterArr)
              for (let s = 0; s < uniqueArr.length; s++) {
                for (let k = 0; k < that.fileListMaster.length; k++) {
                  if (uniqueArr[s] == that.fileListMaster[k].uid) {
                    PhotoArr2.push(that.fileListMaster[k])
                    uniqueArr = uniqueArr.splice(s, 1)
                    s--
                    console.log(this.unique(fileListMasterArr).length)
                  }
                }
              }
              // console.log(this.unique(fileListMasterArr),'this.unique(fileListMasterArr)')
              // console.log(PhotoArr2,'PhotoArr2')
              that.fileListMaster = PhotoArr2
            }
          } else {
            this.$message.error(res.msg)
          }
        })
        // 安装信息
        gettemplateselectInfo({
          orderType: this.selectedRows[0].orderType,
          installType: this.selectedRows[0].installType,
        }).then((res) => {
          if (res.code === 0) {
            if (res.data) {
              if (res.data != '无模板可用') {
                if (res.data.installationInfoList.length > 0) {
                  this.installationInfoList = res.data.installationInfoList
                } else {
                  this.installationInfoList = []
                }
              } else {
                this.installationInfoList = []
              }
            } else {
              this.installationInfoList = []
            }
          } else {
            this.$message.error(res.msg)
          }
        })
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(
              this.selectedRows[0],
              'originalOrderNo',
              'installType',
              'orderType',
              'infoSourceId',
              'payType',
              'enterpriseId',
              'brandId',
              'modelId',
              'buyChannelId',
              'clientName',
              'clientPhone',
              'provinceCode',
              'cityCode',
              'areaCode',
              'clientAddress'
            )
          )
        })
      } else {
        this.$message.error('代入信息只能选择一个')
      }
    },
    incompleteOk() {
      this.incompleteible = false
    },
    // 移除取消时调用的方法
    confirmCancel() {
      this.removeible = false
      this.incompleteible = false
      this.orderid = []
    },
    // 解析表单的解析回显
    async addressResolution() {
      if (this.resolution) {
        await getanalysisText(this.resolution).then((res) => {
          this.dataAll = res.data
          console.log(this.dataAll)
          if (res.code === 0) {
            this.ordervalue = res.data.clientRequire
            for (const item of this.selectAllProvince) {
              if (item.provinceName == this.dataAll.provinceName) {
                this.dataAll.provinceCode = item.provinceCode
              }
            }
            getselectCityName({ provinceCode: this.dataAll.provinceCode })
              .then((res) => {
                if (res.code === 0) {
                  console.log('1', res)
                  this.selectCityName = res.rows
                } else {
                  this.$message.error(res.msg)
                }
              })
              .then((res) => {
                for (const item of this.selectCityName) {
                  if (item.cityName == this.dataAll.cityName) {
                    this.dataAll.cityCode = item.cityCode
                  }
                }
                getselectAreaName({ cityCode: this.dataAll.cityCode })
                  .then((res) => {
                    if (res.code === 0) {
                      this.selectAreaName = res.rows
                      for (const item of this.selectAreaName) {
                        // console.log(item.areaName, this.dataAll.areaName)
                        if (item.areaName == this.dataAll.areaName) {
                          this.dataAll.areaCode = item.areaCode
                        }
                      }
                    } else {
                      this.$message.error(res.msg)
                    }
                  })
                  .then((res) => {
                    this.$nextTick(() => {
                      console.log(888, this.dataAll)
                      this.form.setFieldsValue({
                        provinceCode: this.dataAll.provinceCode,
                        cityCode: this.dataAll.cityCode,
                        areaCode: this.dataAll.areaCode,
                      })
                    })
                  })
              })

            if (res.data.clientName) {
              setTimeout(
                () =>
                  this.form.setFieldsValue({
                    clientName: res.data.clientName,
                  }),
                16
              )
            }
            if (res.data.clientPhone) {
              setTimeout(
                () =>
                  this.form.setFieldsValue({
                    clientPhone: res.data.clientPhone,
                  }),
                16
              )
            }
            this.form.setFieldsValue({
              clientAddress: res.data.town + res.data.clientAddress,
            })
            getsearchMatchOrder({
              clientAddress: res.data.clientAddress,
            }).then((res) => {
              if (res.code === 0) {
                if (res.data.length > 0) {
                  this.$message.success('有关联信息')
                }
              } else {
                this.$message.error(res.msg)
              }
            })
            getsearchMatchOrder({
              clientPhone: res.data.clientPhone,
            }).then((res) => {
              if (res.code === 0) {
                if (res.data.length > 0) {
                  this.$message.success('有关联信息')
                }
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error('请输入需要解析的内容')
      }
    },
    addTab() {
      if (this.accessoryList.length < 5) {
        this.accessoryList.push({
          isMain: true,
          transportCode: '',
          transportName: '',
          transportNo: '',
          remark: '',
        })
      } else {
        this.$message.error('最多添加5条包裹')
      }
    },
    onChangeImportant(i, e) {
      this.accessoryList[i].isMain = e.target.checked
    },

    // 市
    getselect(e) {
      this.provinceCode = e
      getselectCityName({ provinceCode: e }).then((res) => {
        if (res.code === 0) {
          // console.log(res)
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
      this.form.setFieldsValue({
        cityCode: '',
      })
      this.form.setFieldsValue({
        areaCode: '',
      })
    },
    // 区
    getprovinceName(e) {
      console.log(e)
      getselectAreaName({ cityCode: e }).then((res) => {
        if (res.code === 0) {
          // console.log(res)
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
      this.form.setFieldsValue({
        areaCode: '',
      })
    },
    backs() {
      this.visible = false
    },
    changefixSubmission() {
      this.visible = !this.visible
    },
    cancelAccessories() {
      this.time_list = ''
    },
    addAccessories() {
      this.time_list = ''
      this.formaccessories.validateFields((err, values) => {
        values.accessoryType = this.parts.accessoryType
        values.accessorySpecification = this.parts.accessorySpecification
        values.accessoryCategory = this.parts.accessoryCategory
        values.accessoryName = this.parts.accessoryName
        values.repositoryId = this.parts.repositoryId
        values.transportCode = this.parts.transportCode
        values.deliveryTime = this.parts.deliveryTime
        // 师傅单价和总金额默认为0
        values.masterPrice = 0
        values.masterTotalAmount = 0
        if (!err) {
          console.log(values)
          this.disable = false
          if (this.accessoryEditrecord) {
            // 当没有多余tab时就不再删除
            this.loadDataPj[this.editIndex] = values
            this.loadDataPj = _.cloneDeep(this.loadDataPj)
          } else {
            this.loadDataPj.push(values)
          }
        }
      })
    },
    onChangeT(date, dateString) {
      this.parts.deliveryTime = dateString
    },
    onChangeinfo() {
      this.showh = !this.showh
    },
    // 新增配件
    showbtn() {
      this.accessoryEditrecord = ''
      this.formaccessories.resetFields()
      this.showh = false
      this.disable = true
      this.EnterpriseAccessory = []
      // 查询配件下拉框
      getqueryEnterpriseAccessory({
        brandId: this.form.getFieldValue('brandId'),
        modelId: this.form.getFieldValue('modelId'),
        installType: this.form.getFieldValue('installType'),
        enterpriseId: this.enterpriseId,
      }).then((res) => {
        if (res.code === 0) {
          this.EnterpriseAccessory = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    async handleEdit(record, index) {
      this.editIndex = index
      this.accessoryEditrecord = record
      this.formaccessories.resetFields()
      this.$nextTick(() => {
        this.formaccessories.setFieldsValue(
          pick(
            record,
            'orderAccessoryId',
            'accessoryId',
            'price',
            'transportId',
            'accessoryNum',
            'totalAmount',
            'repositoryName',
            'transportlabel',
            'transportNo',
            'sendUser',
            'receiveUser',
            'transportRemark'
          )
        )
      })
      this.time_list = ''
      if (record.deliveryTime) {
        this.time_list = moment(record.deliveryTime, this.dateFormat)
      }
      this.disable = true
      this.showh = true
      this.queryEnterpriseStock = []
      // 获取企业配件金额
      await getqueryEnterpriseAccessoryPrice({
        accessoryId: record.accessoryId,
        enterpriseId: this.enterpriseId,
      }).then((res) => {
        if (res.code === 0) {
          /* console.log(res.data) */
          setTimeout(() => {
            this.formaccessories.setFieldsValue({
              price: res.data.price,
              // amount: 222,
            })
          }, 100)
          // this.parts.price = res.data.price
          this.parts.accessoryType = res.data.accessoryType
          this.parts.accessorySpecification = res.data.accessorySpecification
          this.parts.accessoryCategory = res.data.accessoryCategory
          this.parts.accessoryName = res.data.accessoryName
        } else {
          this.$message.error(res.msg)
        }
      })
      // 获取仓库
      await getqueryEnterpriseStock({
        accessoryId: record.accessoryId,
        enterpriseId: this.enterpriseId,
        useNum: record.accessoryNum,
      }).then((res) => {
        if (res.code === 0) {
          this.queryEnterpriseStock = []
          this.queryEnterpriseStock = res.data.filter((item) => item.storeName)
          /* console.log(res) */
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleAdd() {
      this.$refs.modal.add()
    },
    toTop(i) {
      // 参数i表示间隔的幅度大小，以此来控制速度
      document.documentElement.scrollTop -= i
      if (document.documentElement.scrollTop > 0) {
        var c = setTimeout(() => this.toTop(i), 16)
      } else {
        clearTimeout(c)
      }
    },
    // 上传1
    handleCancel() {
      this.previewVisible = false
    },

    handleChange({ fileList }) {
      this.fileList = fileList
    },
    // 上传2
    handleCanceltwo() {
      this.previewVisibletwo = false
    },
    handlePreviewtwo(file) {
      this.previewImagetwo = file.url || file.thumbUrl
      this.previewVisibletwo = true
      // 在里面调禁用的接口
    },
    handleChangetwo({ fileListtwo }) {
      this.fileListtwo = fileListtwo
    },

    handleChangekd(value) {
      console.log(`selected ${value}`)
    },
    onChange(value) {
      console.log(value)
    },
    delByIds(ids) {},
    changefix(affixed) {
      // console.log(affixed)
    },
    unique(arr) {
      if (!Array.isArray(arr)) {
        console.log('type error!')
        return
      }
      return Array.from(new Set(arr))
    },
  },

  computed: {
    totalAmount() {},
  },
}
</script>

<style scoped>
.orderKeyword {
  font-family: 黑体;
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0px 0px 10px;
}

.okt {
  font-family: 黑体;
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0px 0px 10px;
}

.imp >>> .ant-checkbox-inner {
  width: 25px;
  height: 25px;
  border-radius: 20px;
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ions {
  font-size: 25px;
}

.video {
  width: 130px;
  height: 150px;
  margin: 10px;

  position: relative;
}

.img {
  position: absolute;
  margin-left: -40px;
  margin-top: 23px;
}

.img:hover {
  cursor: pointer;
  color: red;
  z-index: 10000;
}

.video i {
  position: absolute;
  top: 0;
  width: 150px;
  height: 150px;
  background-color: #fff;
  transition: background-color 0.5s;
}

.img:hover i {
  z-index: 1000;
  background-color: rgba(251, 251, 251, 0.3);
}

/deep/ .notshow {
  display: none;
}

/deep/ .ant-table th {
  white-space: nowrap;
}

/deep/ .ant-table td {
  white-space: nowrap;
  padding: 6px 16px;
}

/deep/ .has-error .ant-form-explain,
.has-error .ant-form-split {
  color: #f5222d;
  margin-left: 140px;
}
